// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../public/fonts/DMSans.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../public/fonts/Inter-VariableFont_opsz,wght.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../public/fonts/CalSans-SemiBold.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `*, ::before, ::after {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
  --tw-contain-size:  ;
  --tw-contain-layout:  ;
  --tw-contain-paint:  ;
  --tw-contain-style:  ;
}

::backdrop {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
  --tw-contain-size:  ;
  --tw-contain-layout:  ;
  --tw-contain-paint:  ;
  --tw-contain-style:  ;
}/*
! tailwindcss v3.4.14 | MIT License | https://tailwindcss.com
*//*
1. Prevent padding and border from affecting element width. (https://github.com/mozdevs/cssremedy/issues/4)
2. Allow adding a border to an element by just adding a border-width. (https://github.com/tailwindcss/tailwindcss/pull/116)
*/

*,
::before,
::after {
  box-sizing: border-box; /* 1 */
  border-width: 0; /* 2 */
  border-style: solid; /* 2 */
  border-color: #e5e7eb; /* 2 */
}

::before,
::after {
  --tw-content: '';
}

/*
1. Use a consistent sensible line-height in all browsers.
2. Prevent adjustments of font size after orientation changes in iOS.
3. Use a more readable tab size.
4. Use the user's configured \`sans\` font-family by default.
5. Use the user's configured \`sans\` font-feature-settings by default.
6. Use the user's configured \`sans\` font-variation-settings by default.
7. Disable tap highlights on iOS
*/

html,
:host {
  line-height: 1.5; /* 1 */
  -webkit-text-size-adjust: 100%; /* 2 */ /* 3 */
  tab-size: 4; /* 3 */
  font-family: ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"; /* 4 */
  font-feature-settings: normal; /* 5 */
  font-variation-settings: normal; /* 6 */
  -webkit-tap-highlight-color: transparent; /* 7 */
}

/*
1. Remove the margin in all browsers.
2. Inherit line-height from \`html\` so users can set them as a class directly on the \`html\` element.
*/

body {
  margin: 0; /* 1 */
  line-height: inherit; /* 2 */
}

/*
1. Add the correct height in Firefox.
2. Correct the inheritance of border color in Firefox. (https://bugzilla.mozilla.org/show_bug.cgi?id=190655)
3. Ensure horizontal rules are visible by default.
*/

hr {
  height: 0; /* 1 */
  color: inherit; /* 2 */
  border-top-width: 1px; /* 3 */
}

/*
Add the correct text decoration in Chrome, Edge, and Safari.
*/

abbr:where([title]) {
  -webkit-text-decoration: underline dotted;
          text-decoration: underline dotted;
}

/*
Remove the default font size and weight for headings.
*/

h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: inherit;
  font-weight: inherit;
}

/*
Reset links to optimize for opt-in styling instead of opt-out.
*/

a {
  color: inherit;
  text-decoration: inherit;
}

/*
Add the correct font weight in Edge and Safari.
*/

b,
strong {
  font-weight: bolder;
}

/*
1. Use the user's configured \`mono\` font-family by default.
2. Use the user's configured \`mono\` font-feature-settings by default.
3. Use the user's configured \`mono\` font-variation-settings by default.
4. Correct the odd \`em\` font sizing in all browsers.
*/

code,
kbd,
samp,
pre {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace; /* 1 */
  font-feature-settings: normal; /* 2 */
  font-variation-settings: normal; /* 3 */
  font-size: 1em; /* 4 */
}

/*
Add the correct font size in all browsers.
*/

small {
  font-size: 80%;
}

/*
Prevent \`sub\` and \`sup\` elements from affecting the line height in all browsers.
*/

sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}

/*
1. Remove text indentation from table contents in Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=999088, https://bugs.webkit.org/show_bug.cgi?id=201297)
2. Correct table border color inheritance in all Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=935729, https://bugs.webkit.org/show_bug.cgi?id=195016)
3. Remove gaps between table borders by default.
*/

table {
  text-indent: 0; /* 1 */
  border-color: inherit; /* 2 */
  border-collapse: collapse; /* 3 */
}

/*
1. Change the font styles in all browsers.
2. Remove the margin in Firefox and Safari.
3. Remove default padding in all browsers.
*/

button,
input,
optgroup,
select,
textarea {
  font-family: inherit; /* 1 */
  font-feature-settings: inherit; /* 1 */
  font-variation-settings: inherit; /* 1 */
  font-size: 100%; /* 1 */
  font-weight: inherit; /* 1 */
  line-height: inherit; /* 1 */
  letter-spacing: inherit; /* 1 */
  color: inherit; /* 1 */
  margin: 0; /* 2 */
  padding: 0; /* 3 */
}

/*
Remove the inheritance of text transform in Edge and Firefox.
*/

button,
select {
  text-transform: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Remove default button styles.
*/

button,
input:where([type='button']),
input:where([type='reset']),
input:where([type='submit']) {
  -webkit-appearance: button; /* 1 */
  background-color: transparent; /* 2 */
  background-image: none; /* 2 */
}

/*
Use the modern Firefox focus style for all focusable elements.
*/

:-moz-focusring {
  outline: auto;
}

/*
Remove the additional \`:invalid\` styles in Firefox. (https://github.com/mozilla/gecko-dev/blob/2f9eacd9d3d995c937b4251a5557d95d494c9be1/layout/style/res/forms.css#L728-L737)
*/

:-moz-ui-invalid {
  box-shadow: none;
}

/*
Add the correct vertical alignment in Chrome and Firefox.
*/

progress {
  vertical-align: baseline;
}

/*
Correct the cursor style of increment and decrement buttons in Safari.
*/

::-webkit-inner-spin-button,
::-webkit-outer-spin-button {
  height: auto;
}

/*
1. Correct the odd appearance in Chrome and Safari.
2. Correct the outline style in Safari.
*/

[type='search'] {
  -webkit-appearance: textfield; /* 1 */
  outline-offset: -2px; /* 2 */
}

/*
Remove the inner padding in Chrome and Safari on macOS.
*/

::-webkit-search-decoration {
  -webkit-appearance: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Change font properties to \`inherit\` in Safari.
*/

::-webkit-file-upload-button {
  -webkit-appearance: button; /* 1 */
  font: inherit; /* 2 */
}

/*
Add the correct display in Chrome and Safari.
*/

summary {
  display: list-item;
}

/*
Removes the default spacing and border for appropriate elements.
*/

blockquote,
dl,
dd,
h1,
h2,
h3,
h4,
h5,
h6,
hr,
figure,
p,
pre {
  margin: 0;
}

fieldset {
  margin: 0;
  padding: 0;
}

legend {
  padding: 0;
}

ol,
ul,
menu {
  list-style: none;
  margin: 0;
  padding: 0;
}

/*
Reset default styling for dialogs.
*/
dialog {
  padding: 0;
}

/*
Prevent resizing textareas horizontally by default.
*/

textarea {
  resize: vertical;
}

/*
1. Reset the default placeholder opacity in Firefox. (https://github.com/tailwindlabs/tailwindcss/issues/3300)
2. Set the default placeholder color to the user's configured gray 400 color.
*/

input::placeholder,
textarea::placeholder {
  opacity: 1; /* 1 */
  color: #9ca3af; /* 2 */
}

/*
Set the default cursor for buttons.
*/

button,
[role="button"] {
  cursor: pointer;
}

/*
Make sure disabled buttons don't get the pointer cursor.
*/
:disabled {
  cursor: default;
}

/*
1. Make replaced elements \`display: block\` by default. (https://github.com/mozdevs/cssremedy/issues/14)
2. Add \`vertical-align: middle\` to align replaced elements more sensibly by default. (https://github.com/jensimmons/cssremedy/issues/14#issuecomment-634934210)
   This can trigger a poorly considered lint error in some tools but is included by design.
*/

img,
svg,
video,
canvas,
audio,
iframe,
embed,
object {
  display: block; /* 1 */
  vertical-align: middle; /* 2 */
}

/*
Constrain images and videos to the parent width and preserve their intrinsic aspect ratio. (https://github.com/mozdevs/cssremedy/issues/14)
*/

img,
video {
  max-width: 100%;
  height: auto;
}

/* Make elements with the HTML hidden attribute stay hidden by default */
[hidden]:where(:not([hidden="until-found"])) {
  display: none;
}:root{--background: #0E0E0E;--foreground: #d7d7d7;--primary: #17181d;--secondary: #47E0E7;--third: #272d31;--active: #262d31;--btn-bg: #47E0E7;--btn-bg--active: #33DAE1;--btn-bg--hover: #47E0E7;--btn-bg--outline: #30393C;--btn-bg--outline-hover: #262525;--btn-border: #2DC6CC;--btn-border--active: #33DAE1;--btn-border--hover: #33DAE1;--btn-border--outline: #30393C;--btn-text: #000000;--btn-text--active: #000000;--btn-text--hover: #000000;--radius: 5px}*{font-family:"DMSans";font-family: DMSans, sans-serif}body {
  scroll-behavior: smooth;
  --tw-bg-opacity: 1;
  background-color: rgb(0 0 0 / var(--tw-bg-opacity));
  color: var(--foreground);
}@media screen and (max-width: 1024px){body .container {
    padding-left: 1rem;
    padding-right: 1rem;
  }}a {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity));
  transition-duration: 150ms;
}a:hover{color:#47e0e7}button.hamburger {
  padding-top: 6.5px;
  padding-bottom: 6.5px;
  padding-left: 1rem;
  padding-right: 1rem;
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity));
}button.hamburger svg{width:18px;height:18px}@media screen and (max-width: 767px){button.hamburger{padding:9px 10px}}.font-inter{font-family:"Inter"}.font-dmSans{font-family:"DMSans"}.font-calSans{font-family:"CalSans"}.default-btn,.default-btn {
  border-width: 1px;
  border-color: var(--btn-border);
  background-color: var(--btn-bg);
  text-align: center;
  font-weight: 700;
  color: var(--btn-text);
  transition-duration: 150ms;background:linear-gradient(90.47deg, #38C8CE 0.41%, #6DF9FF 65.55%, #20E1E9 112.38%);
}.default-btn.outlined,.default-btn.outlined {
  border-bottom-width: 1px;
  background-color: transparent;
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity));
}.default-btn.outlined:hover,.default-btn.outlined:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity));
  color: var(--btn-text);
}.default-btn.outlined,.default-btn.outlined{background:none}.default-btn.secondary,.default-btn.secondary {
  border-style: none;
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity));background:none;
}.default-btn:hover:not(:disabled),.default-btn:hover:not(:disabled) {
  border-width: 1px;
  border-color: var(--btn-bg--hover);
  background-color: var(--btn-bg--hover);
  color: var(--btn-text--hover);background:linear-gradient(90.47deg, #20E1E9 0.41%, #6DF9FF 65.55%, #38C8CE 112.38%);
}.default-btn.secondary:hover:not(:disabled),.default-btn.secondary:hover:not(:disabled) {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity));background:none;background-color:#262525;
}.default-btn:active:not(:disabled),.default-btn:active:not(:disabled) {
  background-color: var(--btn-bg--active);
  color: var(--btn-text--active);
}.default-btn:disabled,.default-btn:disabled {
  cursor: not-allowed;
  --tw-border-opacity: 1;
  border-color: rgb(80 121 123 / var(--tw-border-opacity));
  --tw-bg-opacity: 1;
  background-color: rgb(80 121 123 / var(--tw-bg-opacity));
  --tw-text-opacity: 1;
  color: rgb(39 40 44 / var(--tw-text-opacity));
}.orange-sun {
  inset: -20% auto auto 10%;
  height: 18rem;
  width: 18rem;
  border-radius: 9999px;
  --tw-bg-opacity: 1;
  background-color: rgb(255 168 87 / var(--tw-bg-opacity));
  --tw-blur: blur(200px);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}.footer {
  display: flex;
  flex-direction: column;
  gap: 5rem;
}.footer .get-started {
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom-width: 2px;
  --tw-border-opacity: 1;
  border-bottom-color: rgb(127 130 146 / var(--tw-border-opacity));
  padding-top: 1rem;
  padding-bottom: 1rem;
  transition-duration: 500ms;
}.footer .get-started:hover {
  border-bottom-color: var(--secondary);
}.footer .get-started img {
  height: 2rem;
  width: 2rem;
  transition-duration: 500ms;
}.footer .get-started:hover img {
  --tw-scale-x: 1.25;
  --tw-scale-y: 1.25;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}.faq {
  display: flex;
  width: 100%;
  flex-direction: column;
  border-radius: var(--radius);
  border-width: 2px;
  --tw-border-opacity: 1;
  border-color: rgb(59 59 59 / var(--tw-border-opacity));
  transition-property: all;
  transition-duration: 300ms;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
}.faq:hover {
  border-color: var(--secondary);
}.faq button.faq-btn {
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: space-between;
  --tw-bg-opacity: 1;
  background-color: rgb(41 43 50 / var(--tw-bg-opacity));
  padding: 1rem;
  text-align: left;
  font-size: 1.125rem;
  line-height: 1.75rem;
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity));
}@media (min-width: 768px) {

  .faq button.faq-btn {
    font-size: 1.25rem;
    line-height: 1.75rem;
  }
}@media (min-width: 1024px) {

  .faq button.faq-btn {
    padding-left: 1.25rem;
    padding-right: 1.25rem;
    padding-top: 1.5rem;
    padding-bottom: 1.5rem;
    font-size: 1.5rem;
    line-height: 2rem;
  }
}.faq button.faq-btn span {
  --tw-text-opacity: 1;
  color: rgb(107 112 148 / var(--tw-text-opacity));
  transition-property: all;
  transition-duration: 300ms;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
}.faq button.faq-btn.opened span {
  --tw-rotate: 180deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  color: var(--secondary);
}.faq .answer {
  display: grid;
  grid-template-rows: 0fr;
  overflow: hidden;
  padding-left: 1rem;
  padding-right: 1rem;
  padding-top: 0px;
  padding-bottom: 0px;
  font-size: 1.125rem;
  line-height: 1.75rem;
  opacity: 0;
  transition-property: all;
  transition-duration: 300ms;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
}@media (min-width: 1024px) {

  .faq .answer {
    padding-left: 1.25rem;
    padding-right: 1.25rem;
  }
}.faq .answer.opened {
  grid-template-rows: 1fr;
  padding-top: 1rem;
  padding-bottom: 1rem;
  opacity: 1;
}@media (min-width: 1024px) {

  .faq .answer.opened {
    padding-top: 2rem;
    padding-bottom: 2rem;
  }
}.btn-plan.active {
  --tw-border-opacity: 1;
  border-color: rgb(174 228 230 / var(--tw-border-opacity));
  background-color: #AEE4E61A;
}.btn-tier .name {
  font-size: 0.875rem;
  line-height: 1.25rem;
  font-weight: 700;
  line-height: 21.6px;
  --tw-text-opacity: 1;
  color: rgb(172 172 172 / var(--tw-text-opacity));
}@media (min-width: 1280px) {

  .btn-tier .name {
    font-size: 1.125rem;
    line-height: 1.75rem;
  }
}.btn-tier:hover,.btn-tier.active {
  --tw-border-opacity: 1;
  border-color: rgb(174 228 230 / var(--tw-border-opacity));
  background-color: #AEE4E61A;
  --tw-text-opacity: 1;
  color: rgb(227 227 227 / var(--tw-text-opacity));
}.btn-tier:hover .name,.btn-tier.active .name {
  --tw-text-opacity: 1;
  color: rgb(174 228 230 / var(--tw-text-opacity));
}.btn-tier .icon-wrapper>svg.icon {
  opacity: 1;
}.btn-tier.active .icon-wrapper .icon {
  opacity: 0;
}.btn-tier.active .icon-wrapper .icon--selected {
  opacity: 1;
}.btn-tier .benefit-item .icon {
  display: inline-flex;
  max-height: 1.25rem;
  min-height: 1.25rem;
  min-width: 1.25rem;
  max-width: 1.25rem;
  align-items: center;
  justify-content: center;
  border-radius: 9999px;
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity));
}.btn-tier .benefit-item .icon svg {
  opacity: 0;
}.btn-tier.active .benefit-item .icon {
  --tw-bg-opacity: 1;
  background-color: rgb(174 228 230 / var(--tw-bg-opacity));
}.btn-tier.active .benefit-item .icon svg {
  opacity: 1;
}.btn-tier.active .benefit-item .icon svg path{fill:#17181d}.container {
  width: 100%;
}@media (min-width: 640px) {

  .container {
    max-width: 640px;
  }
}@media (min-width: 768px) {

  .container {
    max-width: 768px;
  }
}@media (min-width: 1024px) {

  .container {
    max-width: 1024px;
  }
}@media (min-width: 1280px) {

  .container {
    max-width: 1280px;
  }
}@media (min-width: 1536px) {

  .container {
    max-width: 1536px;
  }
}.pointer-events-none {
  pointer-events: none;
}.pointer-events-auto {
  pointer-events: auto;
}.visible {
  visibility: visible;
}.invisible {
  visibility: hidden;
}.fixed {
  position: fixed;
}.absolute {
  position: absolute;
}.relative {
  position: relative;
}.sticky {
  position: sticky;
}.inset-0 {
  inset: 0px;
}.inset-y-0 {
  top: 0px;
  bottom: 0px;
}.bottom-0 {
  bottom: 0px;
}.left-0 {
  left: 0px;
}.left-\\[-10px\\] {
  left: -10px;
}.left-\\[-120px\\] {
  left: -120px;
}.left-\\[20\\%\\] {
  left: 20%;
}.left-\\[calc\\(50\\%-24px\\)\\] {
  left: calc(50% - 24px);
}.right-0 {
  right: 0px;
}.right-4 {
  right: 1rem;
}.right-5 {
  right: 1.25rem;
}.right-\\[-120px\\] {
  right: -120px;
}.right-\\[-35px\\] {
  right: -35px;
}.top-0 {
  top: 0px;
}.top-4 {
  top: 1rem;
}.top-5 {
  top: 1.25rem;
}.top-\\[-235px\\] {
  top: -235px;
}.top-\\[-24px\\] {
  top: -24px;
}.top-\\[-25px\\] {
  top: -25px;
}.top-\\[-75px\\] {
  top: -75px;
}.top-\\[10\\%\\] {
  top: 10%;
}.top-\\[20px\\] {
  top: 20px;
}.z-0 {
  z-index: 0;
}.z-10 {
  z-index: 10;
}.z-50 {
  z-index: 50;
}.z-\\[100\\] {
  z-index: 100;
}.z-\\[110\\] {
  z-index: 110;
}.z-\\[1\\] {
  z-index: 1;
}.col-span-2 {
  grid-column: span 2 / span 2;
}.m-auto {
  margin: auto;
}.mx-0 {
  margin-left: 0px;
  margin-right: 0px;
}.mx-4 {
  margin-left: 1rem;
  margin-right: 1rem;
}.mx-5 {
  margin-left: 1.25rem;
  margin-right: 1.25rem;
}.mx-auto {
  margin-left: auto;
  margin-right: auto;
}.my-0 {
  margin-top: 0px;
  margin-bottom: 0px;
}.my-4 {
  margin-top: 1rem;
  margin-bottom: 1rem;
}.my-5 {
  margin-top: 1.25rem;
  margin-bottom: 1.25rem;
}.my-6 {
  margin-top: 1.5rem;
  margin-bottom: 1.5rem;
}.my-\\[22px\\] {
  margin-top: 22px;
  margin-bottom: 22px;
}.my-auto {
  margin-top: auto;
  margin-bottom: auto;
}.mb-0 {
  margin-bottom: 0px;
}.mb-1 {
  margin-bottom: 0.25rem;
}.mb-10 {
  margin-bottom: 2.5rem;
}.mb-11 {
  margin-bottom: 2.75rem;
}.mb-14 {
  margin-bottom: 3.5rem;
}.mb-2 {
  margin-bottom: 0.5rem;
}.mb-3 {
  margin-bottom: 0.75rem;
}.mb-4 {
  margin-bottom: 1rem;
}.mb-5 {
  margin-bottom: 1.25rem;
}.mb-6 {
  margin-bottom: 1.5rem;
}.mb-7 {
  margin-bottom: 1.75rem;
}.mb-8 {
  margin-bottom: 2rem;
}.mb-\\[12px\\] {
  margin-bottom: 12px;
}.mb-\\[18px\\] {
  margin-bottom: 18px;
}.mb-\\[20px\\] {
  margin-bottom: 20px;
}.mb-\\[30px\\] {
  margin-bottom: 30px;
}.mb-\\[71px\\] {
  margin-bottom: 71px;
}.ml-1 {
  margin-left: 0.25rem;
}.ml-12 {
  margin-left: 3rem;
}.ml-2 {
  margin-left: 0.5rem;
}.ml-3 {
  margin-left: 0.75rem;
}.ml-6 {
  margin-left: 1.5rem;
}.ml-\\[25px\\] {
  margin-left: 25px;
}.mr-3 {
  margin-right: 0.75rem;
}.mr-4 {
  margin-right: 1rem;
}.mt-0 {
  margin-top: 0px;
}.mt-0\\.5 {
  margin-top: 0.125rem;
}.mt-1 {
  margin-top: 0.25rem;
}.mt-1\\.5 {
  margin-top: 0.375rem;
}.mt-10 {
  margin-top: 2.5rem;
}.mt-12 {
  margin-top: 3rem;
}.mt-2 {
  margin-top: 0.5rem;
}.mt-2\\.5 {
  margin-top: 0.625rem;
}.mt-3 {
  margin-top: 0.75rem;
}.mt-4 {
  margin-top: 1rem;
}.mt-5 {
  margin-top: 1.25rem;
}.mt-6 {
  margin-top: 1.5rem;
}.mt-7 {
  margin-top: 1.75rem;
}.mt-8 {
  margin-top: 2rem;
}.mt-\\[-100px\\] {
  margin-top: -100px;
}.mt-\\[-28px\\] {
  margin-top: -28px;
}.mt-\\[-30px\\] {
  margin-top: -30px;
}.mt-\\[-50px\\] {
  margin-top: -50px;
}.mt-\\[-60px\\] {
  margin-top: -60px;
}.mt-\\[-80px\\] {
  margin-top: -80px;
}.mt-\\[10px\\] {
  margin-top: 10px;
}.mt-\\[114px\\] {
  margin-top: 114px;
}.mt-\\[16px\\] {
  margin-top: 16px;
}.mt-\\[20px\\] {
  margin-top: 20px;
}.mt-\\[44px\\] {
  margin-top: 44px;
}.mt-\\[55px\\] {
  margin-top: 55px;
}.mt-\\[70px\\] {
  margin-top: 70px;
}.block {
  display: block;
}.flex {
  display: flex;
}.inline-flex {
  display: inline-flex;
}.table {
  display: table;
}.grid {
  display: grid;
}.contents {
  display: contents;
}.hidden {
  display: none;
}.h-12 {
  height: 3rem;
}.h-16 {
  height: 4rem;
}.h-2\\.5 {
  height: 0.625rem;
}.h-4 {
  height: 1rem;
}.h-5 {
  height: 1.25rem;
}.h-6 {
  height: 1.5rem;
}.h-7 {
  height: 1.75rem;
}.h-8 {
  height: 2rem;
}.h-9 {
  height: 2.25rem;
}.h-\\[0px\\] {
  height: 0px;
}.h-\\[130px\\] {
  height: 130px;
}.h-\\[133px\\] {
  height: 133px;
}.h-\\[146px\\] {
  height: 146px;
}.h-\\[170px\\] {
  height: 170px;
}.h-\\[190px\\] {
  height: 190px;
}.h-\\[231px\\] {
  height: 231px;
}.h-\\[26px\\] {
  height: 26px;
}.h-\\[343px\\] {
  height: 343px;
}.h-\\[35px\\] {
  height: 35px;
}.h-\\[375px\\] {
  height: 375px;
}.h-\\[42px\\] {
  height: 42px;
}.h-\\[48px\\] {
  height: 48px;
}.h-\\[500px\\] {
  height: 500px;
}.h-\\[56px\\] {
  height: 56px;
}.h-\\[60px\\] {
  height: 60px;
}.h-\\[74px\\] {
  height: 74px;
}.h-\\[calc\\(100vh-152px\\)\\] {
  height: calc(100vh - 152px);
}.h-auto {
  height: auto;
}.h-fit {
  height: fit-content;
}.h-full {
  height: 100%;
}.min-h-\\[40px\\] {
  min-height: 40px;
}.min-h-screen {
  min-height: 100vh;
}.w-12 {
  width: 3rem;
}.w-16 {
  width: 4rem;
}.w-2\\.5 {
  width: 0.625rem;
}.w-4 {
  width: 1rem;
}.w-5 {
  width: 1.25rem;
}.w-6 {
  width: 1.5rem;
}.w-7 {
  width: 1.75rem;
}.w-8 {
  width: 2rem;
}.w-\\[10px\\] {
  width: 10px;
}.w-\\[166px\\] {
  width: 166px;
}.w-\\[231px\\] {
  width: 231px;
}.w-\\[251px\\] {
  width: 251px;
}.w-\\[26px\\] {
  width: 26px;
}.w-\\[300px\\] {
  width: 300px;
}.w-\\[328px\\] {
  width: 328px;
}.w-\\[339px\\] {
  width: 339px;
}.w-\\[35px\\] {
  width: 35px;
}.w-\\[400px\\] {
  width: 400px;
}.w-\\[408px\\] {
  width: 408px;
}.w-\\[528px\\] {
  width: 528px;
}.w-\\[52px\\] {
  width: 52px;
}.w-\\[56px\\] {
  width: 56px;
}.w-\\[74px\\] {
  width: 74px;
}.w-auto {
  width: auto;
}.w-full {
  width: 100%;
}.w-screen {
  width: 100vw;
}.min-w-\\[320px\\] {
  min-width: 320px;
}.min-w-\\[390px\\] {
  min-width: 390px;
}.max-w-\\[1097px\\] {
  max-width: 1097px;
}.max-w-\\[1108px\\] {
  max-width: 1108px;
}.max-w-\\[1120px\\] {
  max-width: 1120px;
}.max-w-\\[1148px\\] {
  max-width: 1148px;
}.max-w-\\[1191px\\] {
  max-width: 1191px;
}.max-w-\\[1200px\\] {
  max-width: 1200px;
}.max-w-\\[1231px\\] {
  max-width: 1231px;
}.max-w-\\[1240px\\] {
  max-width: 1240px;
}.max-w-\\[1260px\\] {
  max-width: 1260px;
}.max-w-\\[1292px\\] {
  max-width: 1292px;
}.max-w-\\[260px\\] {
  max-width: 260px;
}.max-w-\\[273px\\] {
  max-width: 273px;
}.max-w-\\[283px\\] {
  max-width: 283px;
}.max-w-\\[288px\\] {
  max-width: 288px;
}.max-w-\\[302px\\] {
  max-width: 302px;
}.max-w-\\[306px\\] {
  max-width: 306px;
}.max-w-\\[310px\\] {
  max-width: 310px;
}.max-w-\\[322px\\] {
  max-width: 322px;
}.max-w-\\[335px\\] {
  max-width: 335px;
}.max-w-\\[376px\\] {
  max-width: 376px;
}.max-w-\\[390px\\] {
  max-width: 390px;
}.max-w-\\[420px\\] {
  max-width: 420px;
}.max-w-\\[476px\\] {
  max-width: 476px;
}.max-w-\\[502px\\] {
  max-width: 502px;
}.max-w-\\[612px\\] {
  max-width: 612px;
}.max-w-\\[720px\\] {
  max-width: 720px;
}.max-w-\\[723px\\] {
  max-width: 723px;
}.max-w-\\[804px\\] {
  max-width: 804px;
}.max-w-\\[814px\\] {
  max-width: 814px;
}.max-w-\\[905px\\] {
  max-width: 905px;
}.max-w-md {
  max-width: 28rem;
}.flex-1 {
  flex: 1 1 0%;
}.-translate-x-full {
  --tw-translate-x: -100%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}.translate-x-\\[0px\\] {
  --tw-translate-x: 0px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}.translate-x-full {
  --tw-translate-x: 100%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}.transform {
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}@keyframes spin {

  to {
    transform: rotate(360deg);
  }
}.animate-spin {
  animation: spin 1s linear infinite;
}.cursor-pointer {
  cursor: pointer;
}.resize {
  resize: both;
}.list-inside {
  list-style-position: inside;
}.list-disc {
  list-style-type: disc;
}.grid-cols-1 {
  grid-template-columns: repeat(1, minmax(0, 1fr));
}.grid-cols-2 {
  grid-template-columns: repeat(2, minmax(0, 1fr));
}.flex-row {
  flex-direction: row;
}.flex-col {
  flex-direction: column;
}.flex-wrap {
  flex-wrap: wrap;
}.place-items-center {
  place-items: center;
}.items-start {
  align-items: flex-start;
}.items-end {
  align-items: flex-end;
}.items-center {
  align-items: center;
}.justify-start {
  justify-content: flex-start;
}.justify-center {
  justify-content: center;
}.justify-between {
  justify-content: space-between;
}.gap-0 {
  gap: 0px;
}.gap-1 {
  gap: 0.25rem;
}.gap-1\\.5 {
  gap: 0.375rem;
}.gap-10 {
  gap: 2.5rem;
}.gap-12 {
  gap: 3rem;
}.gap-2 {
  gap: 0.5rem;
}.gap-2\\.5 {
  gap: 0.625rem;
}.gap-3 {
  gap: 0.75rem;
}.gap-3\\.5 {
  gap: 0.875rem;
}.gap-4 {
  gap: 1rem;
}.gap-5 {
  gap: 1.25rem;
}.gap-6 {
  gap: 1.5rem;
}.gap-8 {
  gap: 2rem;
}.gap-\\[10px\\] {
  gap: 10px;
}.gap-\\[12px\\] {
  gap: 12px;
}.gap-\\[14px\\] {
  gap: 14px;
}.gap-\\[30px\\] {
  gap: 30px;
}.gap-\\[38px\\] {
  gap: 38px;
}.gap-\\[3px\\] {
  gap: 3px;
}.gap-\\[45px\\] {
  gap: 45px;
}.gap-\\[50px\\] {
  gap: 50px;
}.gap-\\[9px\\] {
  gap: 9px;
}.gap-x-1\\.5 {
  column-gap: 0.375rem;
}.gap-x-5 {
  column-gap: 1.25rem;
}.gap-x-\\[9px\\] {
  column-gap: 9px;
}.gap-y-1 {
  row-gap: 0.25rem;
}.gap-y-4 {
  row-gap: 1rem;
}.gap-y-5 {
  row-gap: 1.25rem;
}.gap-y-6 {
  row-gap: 1.5rem;
}.space-y-1 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(0.25rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.25rem * var(--tw-space-y-reverse));
}.space-y-2 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(0.5rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.5rem * var(--tw-space-y-reverse));
}.space-y-4 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(1rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(1rem * var(--tw-space-y-reverse));
}.self-center {
  align-self: center;
}.overflow-hidden {
  overflow: hidden;
}.overflow-x-auto {
  overflow-x: auto;
}.overflow-y-auto {
  overflow-y: auto;
}.whitespace-nowrap {
  white-space: nowrap;
}.rounded {
  border-radius: var(--radius);
}.rounded-\\[10px\\] {
  border-radius: 10px;
}.rounded-\\[12px\\] {
  border-radius: 12px;
}.rounded-\\[14px\\] {
  border-radius: 14px;
}.rounded-\\[20px\\] {
  border-radius: 20px;
}.rounded-\\[24px\\] {
  border-radius: 24px;
}.rounded-\\[44px\\] {
  border-radius: 44px;
}.rounded-\\[4px\\] {
  border-radius: 4px;
}.rounded-\\[8px\\] {
  border-radius: 8px;
}.rounded-lg {
  border-radius: 0.5rem;
}.rounded-md {
  border-radius: 0.375rem;
}.rounded-b-2xl {
  border-bottom-right-radius: 1rem;
  border-bottom-left-radius: 1rem;
}.rounded-t-\\[20px\\] {
  border-top-left-radius: 20px;
  border-top-right-radius: 20px;
}.border {
  border-width: 1px;
}.border-b {
  border-bottom-width: 1px;
}.border-b-2 {
  border-bottom-width: 2px;
}.border-l {
  border-left-width: 1px;
}.border-r {
  border-right-width: 1px;
}.border-t {
  border-top-width: 1px;
}.\\!border-solid {
  border-style: solid !important;
}.border-solid {
  border-style: solid;
}.\\!border-none {
  border-style: none !important;
}.border-none {
  border-style: none;
}.border-\\[\\#2B2D39\\] {
  --tw-border-opacity: 1;
  border-color: rgb(43 45 57 / var(--tw-border-opacity));
}.border-\\[\\#3E3E3E\\] {
  --tw-border-opacity: 1;
  border-color: rgb(62 62 62 / var(--tw-border-opacity));
}.border-\\[\\#454545\\] {
  --tw-border-opacity: 1;
  border-color: rgb(69 69 69 / var(--tw-border-opacity));
}.border-\\[\\#727070\\] {
  --tw-border-opacity: 1;
  border-color: rgb(114 112 112 / var(--tw-border-opacity));
}.border-\\[\\#9197A2\\] {
  --tw-border-opacity: 1;
  border-color: rgb(145 151 162 / var(--tw-border-opacity));
}.border-\\[\\#CBD5E1\\] {
  --tw-border-opacity: 1;
  border-color: rgb(203 213 225 / var(--tw-border-opacity));
}.border-\\[\\#D5D5D5\\] {
  --tw-border-opacity: 1;
  border-color: rgb(213 213 213 / var(--tw-border-opacity));
}.border-\\[\\#E4E4E7\\] {
  --tw-border-opacity: 1;
  border-color: rgb(228 228 231 / var(--tw-border-opacity));
}.border-\\[\\#E5E7EB\\] {
  --tw-border-opacity: 1;
  border-color: rgb(229 231 235 / var(--tw-border-opacity));
}.border-\\[\\#fff3\\] {
  border-color: #fff3;
}.border-btn-border {
  border-color: var(--btn-border);
}.border-transparent {
  border-color: transparent;
}.border-white\\/10 {
  border-color: rgb(255 255 255 / 0.1);
}.border-b-secondary {
  border-bottom-color: var(--secondary);
}.\\!bg-\\[\\#303030\\] {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(48 48 48 / var(--tw-bg-opacity)) !important;
}.\\!bg-\\[\\#40cfd5\\] {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(64 207 213 / var(--tw-bg-opacity)) !important;
}.\\!bg-secondary {
  background-color: var(--secondary) !important;
}.\\!bg-transparent {
  background-color: transparent !important;
}.bg-\\[\\#0E0E0E\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(14 14 14 / var(--tw-bg-opacity));
}.bg-\\[\\#141519\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(20 21 25 / var(--tw-bg-opacity));
}.bg-\\[\\#17181D\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(23 24 29 / var(--tw-bg-opacity));
}.bg-\\[\\#1E3A3C\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(30 58 60 / var(--tw-bg-opacity));
}.bg-\\[\\#68EFF5\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(104 239 245 / var(--tw-bg-opacity));
}.bg-\\[\\#F2F2F2\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(242 242 242 / var(--tw-bg-opacity));
}.bg-\\[\\#F9F9F9\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(249 249 249 / var(--tw-bg-opacity));
}.bg-\\[\\#FFF\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity));
}.bg-black {
  --tw-bg-opacity: 1;
  background-color: rgb(0 0 0 / var(--tw-bg-opacity));
}.bg-primary {
  background-color: var(--primary);
}.bg-secondary {
  background-color: var(--secondary);
}.bg-transparent {
  background-color: transparent;
}.bg-white {
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity));
}.bg-white\\/5 {
  background-color: rgb(255 255 255 / 0.05);
}.object-contain {
  object-fit: contain;
}.object-cover {
  object-fit: cover;
}.\\!p-0 {
  padding: 0px !important;
}.p-0 {
  padding: 0px;
}.p-10 {
  padding: 2.5rem;
}.p-12 {
  padding: 3rem;
}.p-2 {
  padding: 0.5rem;
}.p-5 {
  padding: 1.25rem;
}.p-\\[14px\\] {
  padding: 14px;
}.p-\\[2px\\] {
  padding: 2px;
}.p-\\[40px\\] {
  padding: 40px;
}.p-\\[5px\\] {
  padding: 5px;
}.\\!px-0 {
  padding-left: 0px !important;
  padding-right: 0px !important;
}.\\!px-2 {
  padding-left: 0.5rem !important;
  padding-right: 0.5rem !important;
}.\\!px-4 {
  padding-left: 1rem !important;
  padding-right: 1rem !important;
}.\\!py-0 {
  padding-top: 0px !important;
  padding-bottom: 0px !important;
}.\\!py-\\[8\\.5px\\] {
  padding-top: 8.5px !important;
  padding-bottom: 8.5px !important;
}.\\!py-\\[9\\.5px\\] {
  padding-top: 9.5px !important;
  padding-bottom: 9.5px !important;
}.px-0 {
  padding-left: 0px;
  padding-right: 0px;
}.px-1\\.5 {
  padding-left: 0.375rem;
  padding-right: 0.375rem;
}.px-10 {
  padding-left: 2.5rem;
  padding-right: 2.5rem;
}.px-2 {
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}.px-2\\.5 {
  padding-left: 0.625rem;
  padding-right: 0.625rem;
}.px-3 {
  padding-left: 0.75rem;
  padding-right: 0.75rem;
}.px-4 {
  padding-left: 1rem;
  padding-right: 1rem;
}.px-5 {
  padding-left: 1.25rem;
  padding-right: 1.25rem;
}.px-6 {
  padding-left: 1.5rem;
  padding-right: 1.5rem;
}.px-8 {
  padding-left: 2rem;
  padding-right: 2rem;
}.px-\\[14px\\] {
  padding-left: 14px;
  padding-right: 14px;
}.px-\\[30px\\] {
  padding-left: 30px;
  padding-right: 30px;
}.px-\\[36px\\] {
  padding-left: 36px;
  padding-right: 36px;
}.px-\\[97\\.5px\\] {
  padding-left: 97.5px;
  padding-right: 97.5px;
}.px-\\[9px\\] {
  padding-left: 9px;
  padding-right: 9px;
}.py-0\\.5 {
  padding-top: 0.125rem;
  padding-bottom: 0.125rem;
}.py-1 {
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
}.py-10 {
  padding-top: 2.5rem;
  padding-bottom: 2.5rem;
}.py-12 {
  padding-top: 3rem;
  padding-bottom: 3rem;
}.py-16 {
  padding-top: 4rem;
  padding-bottom: 4rem;
}.py-2 {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}.py-2\\.5 {
  padding-top: 0.625rem;
  padding-bottom: 0.625rem;
}.py-3 {
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
}.py-4 {
  padding-top: 1rem;
  padding-bottom: 1rem;
}.py-5 {
  padding-top: 1.25rem;
  padding-bottom: 1.25rem;
}.py-8 {
  padding-top: 2rem;
  padding-bottom: 2rem;
}.py-\\[30px\\] {
  padding-top: 30px;
  padding-bottom: 30px;
}.py-\\[46px\\] {
  padding-top: 46px;
  padding-bottom: 46px;
}.py-\\[4px\\] {
  padding-top: 4px;
  padding-bottom: 4px;
}.py-\\[5px\\] {
  padding-top: 5px;
  padding-bottom: 5px;
}.py-\\[60px\\] {
  padding-top: 60px;
  padding-bottom: 60px;
}.py-\\[7px\\] {
  padding-top: 7px;
  padding-bottom: 7px;
}.py-\\[9\\.5px\\] {
  padding-top: 9.5px;
  padding-bottom: 9.5px;
}.\\!pr-0 {
  padding-right: 0px !important;
}.pb-0 {
  padding-bottom: 0px;
}.pb-4 {
  padding-bottom: 1rem;
}.pb-5 {
  padding-bottom: 1.25rem;
}.pb-\\[10px\\] {
  padding-bottom: 10px;
}.pb-\\[38px\\] {
  padding-bottom: 38px;
}.pb-\\[52px\\] {
  padding-bottom: 52px;
}.pl-2 {
  padding-left: 0.5rem;
}.pl-8 {
  padding-left: 2rem;
}.pr-4 {
  padding-right: 1rem;
}.pr-8 {
  padding-right: 2rem;
}.pt-0 {
  padding-top: 0px;
}.pt-\\[40px\\] {
  padding-top: 40px;
}.pt-\\[46px\\] {
  padding-top: 46px;
}.text-left {
  text-align: left;
}.text-center {
  text-align: center;
}.font-dmSans {
  font-family: DMSans, sans-serif;
}.\\!text-\\[12px\\] {
  font-size: 12px !important;
}.\\!text-\\[14px\\] {
  font-size: 14px !important;
}.\\!text-\\[16px\\] {
  font-size: 16px !important;
}.\\!text-\\[18px\\] {
  font-size: 18px !important;
}.\\!text-\\[20px\\] {
  font-size: 20px !important;
}.\\!text-\\[22px\\] {
  font-size: 22px !important;
}.\\!text-\\[24px\\] {
  font-size: 24px !important;
}.\\!text-\\[28px\\] {
  font-size: 28px !important;
}.\\!text-\\[30px\\] {
  font-size: 30px !important;
}.\\!text-\\[48px\\] {
  font-size: 48px !important;
}.text-2xl {
  font-size: 1.5rem;
  line-height: 2rem;
}.text-\\[10px\\] {
  font-size: 10px;
}.text-\\[10rem\\] {
  font-size: 10rem;
}.text-\\[12px\\] {
  font-size: 12px;
}.text-\\[14px\\] {
  font-size: 14px;
}.text-\\[16px\\] {
  font-size: 16px;
}.text-\\[18px\\] {
  font-size: 18px;
}.text-\\[20px\\] {
  font-size: 20px;
}.text-\\[24px\\] {
  font-size: 24px;
}.text-\\[28px\\] {
  font-size: 28px;
}.text-\\[34px\\] {
  font-size: 34px;
}.text-\\[36px\\] {
  font-size: 36px;
}.text-\\[40px\\] {
  font-size: 40px;
}.text-\\[42px\\] {
  font-size: 42px;
}.text-\\[48px\\] {
  font-size: 48px;
}.text-\\[50px\\] {
  font-size: 50px;
}.text-base {
  font-size: 1rem;
  line-height: 1.5rem;
}.text-lg {
  font-size: 1.125rem;
  line-height: 1.75rem;
}.text-sm {
  font-size: 0.875rem;
  line-height: 1.25rem;
}.text-xl {
  font-size: 1.25rem;
  line-height: 1.75rem;
}.text-xs {
  font-size: 0.75rem;
  line-height: 1rem;
}.\\!font-\\[500\\] {
  font-weight: 500 !important;
}.\\!font-bold {
  font-weight: 700 !important;
}.\\!font-light {
  font-weight: 300 !important;
}.\\!font-semibold {
  font-weight: 600 !important;
}.font-\\[400\\] {
  font-weight: 400;
}.font-bold {
  font-weight: 700;
}.font-light {
  font-weight: 300;
}.font-medium {
  font-weight: 500;
}.font-normal {
  font-weight: 400;
}.font-semibold {
  font-weight: 600;
}.\\!leading-\\[100\\%\\] {
  line-height: 100% !important;
}.\\!leading-\\[20px\\] {
  line-height: 20px !important;
}.\\!leading-\\[26px\\] {
  line-height: 26px !important;
}.\\!leading-\\[36px\\] {
  line-height: 36px !important;
}.leading-4 {
  line-height: 1rem;
}.leading-5 {
  line-height: 1.25rem;
}.leading-6 {
  line-height: 1.5rem;
}.leading-7 {
  line-height: 1.75rem;
}.leading-\\[100\\%\\] {
  line-height: 100%;
}.leading-\\[18px\\] {
  line-height: 18px;
}.leading-\\[20px\\] {
  line-height: 20px;
}.leading-\\[23\\.14px\\] {
  line-height: 23.14px;
}.leading-\\[27px\\] {
  line-height: 27px;
}.leading-\\[28px\\] {
  line-height: 28px;
}.leading-\\[36px\\] {
  line-height: 36px;
}.leading-\\[38px\\] {
  line-height: 38px;
}.leading-\\[48px\\] {
  line-height: 48px;
}.leading-\\[54px\\] {
  line-height: 54px;
}.leading-\\[62px\\] {
  line-height: 62px;
}.leading-\\[normal\\] {
  line-height: normal;
}.leading-none {
  line-height: 1;
}.leading-relaxed {
  line-height: 1.625;
}.tracking-\\[-2\\.5\\%\\] {
  letter-spacing: -2.5%;
}.tracking-\\[0\\.21px\\] {
  letter-spacing: 0.21px;
}.tracking-\\[1\\.5\\%\\] {
  letter-spacing: 1.5%;
}.\\!text-\\[\\#142E2F\\] {
  --tw-text-opacity: 1 !important;
  color: rgb(20 46 47 / var(--tw-text-opacity)) !important;
}.\\!text-\\[\\#243A3A\\] {
  --tw-text-opacity: 1 !important;
  color: rgb(36 58 58 / var(--tw-text-opacity)) !important;
}.\\!text-\\[\\#35E8EF\\] {
  --tw-text-opacity: 1 !important;
  color: rgb(53 232 239 / var(--tw-text-opacity)) !important;
}.\\!text-\\[\\#383838\\] {
  --tw-text-opacity: 1 !important;
  color: rgb(56 56 56 / var(--tw-text-opacity)) !important;
}.\\!text-\\[\\#424242\\] {
  --tw-text-opacity: 1 !important;
  color: rgb(66 66 66 / var(--tw-text-opacity)) !important;
}.\\!text-\\[\\#555555\\] {
  --tw-text-opacity: 1 !important;
  color: rgb(85 85 85 / var(--tw-text-opacity)) !important;
}.\\!text-\\[\\#5F7E7F\\] {
  --tw-text-opacity: 1 !important;
  color: rgb(95 126 127 / var(--tw-text-opacity)) !important;
}.\\!text-\\[\\#68EFF5\\] {
  --tw-text-opacity: 1 !important;
  color: rgb(104 239 245 / var(--tw-text-opacity)) !important;
}.\\!text-\\[\\#899FA0\\] {
  --tw-text-opacity: 1 !important;
  color: rgb(137 159 160 / var(--tw-text-opacity)) !important;
}.\\!text-\\[\\#8A8C93\\] {
  --tw-text-opacity: 1 !important;
  color: rgb(138 140 147 / var(--tw-text-opacity)) !important;
}.\\!text-\\[\\#A0A0A0\\] {
  --tw-text-opacity: 1 !important;
  color: rgb(160 160 160 / var(--tw-text-opacity)) !important;
}.\\!text-\\[\\#A9AAB0\\] {
  --tw-text-opacity: 1 !important;
  color: rgb(169 170 176 / var(--tw-text-opacity)) !important;
}.\\!text-\\[\\#B6B6B6\\] {
  --tw-text-opacity: 1 !important;
  color: rgb(182 182 182 / var(--tw-text-opacity)) !important;
}.\\!text-\\[\\#BDBDBD\\] {
  --tw-text-opacity: 1 !important;
  color: rgb(189 189 189 / var(--tw-text-opacity)) !important;
}.\\!text-\\[\\#C3C3C3\\] {
  --tw-text-opacity: 1 !important;
  color: rgb(195 195 195 / var(--tw-text-opacity)) !important;
}.\\!text-\\[\\#C7C7C7\\] {
  --tw-text-opacity: 1 !important;
  color: rgb(199 199 199 / var(--tw-text-opacity)) !important;
}.\\!text-\\[\\#D9D9D9\\] {
  --tw-text-opacity: 1 !important;
  color: rgb(217 217 217 / var(--tw-text-opacity)) !important;
}.\\!text-\\[\\#E3E3E3\\] {
  --tw-text-opacity: 1 !important;
  color: rgb(227 227 227 / var(--tw-text-opacity)) !important;
}.\\!text-black {
  --tw-text-opacity: 1 !important;
  color: rgb(0 0 0 / var(--tw-text-opacity)) !important;
}.\\!text-white {
  --tw-text-opacity: 1 !important;
  color: rgb(255 255 255 / var(--tw-text-opacity)) !important;
}.text-\\[\\#000\\] {
  --tw-text-opacity: 1;
  color: rgb(0 0 0 / var(--tw-text-opacity));
}.text-\\[\\#0F172A\\] {
  --tw-text-opacity: 1;
  color: rgb(15 23 42 / var(--tw-text-opacity));
}.text-\\[\\#17181D\\] {
  --tw-text-opacity: 1;
  color: rgb(23 24 29 / var(--tw-text-opacity));
}.text-\\[\\#1A1A1A\\] {
  --tw-text-opacity: 1;
  color: rgb(26 26 26 / var(--tw-text-opacity));
}.text-\\[\\#33DAE1\\] {
  --tw-text-opacity: 1;
  color: rgb(51 218 225 / var(--tw-text-opacity));
}.text-\\[\\#47E0E7\\] {
  --tw-text-opacity: 1;
  color: rgb(71 224 231 / var(--tw-text-opacity));
}.text-\\[\\#555555\\] {
  --tw-text-opacity: 1;
  color: rgb(85 85 85 / var(--tw-text-opacity));
}.text-\\[\\#64748B\\] {
  --tw-text-opacity: 1;
  color: rgb(100 116 139 / var(--tw-text-opacity));
}.text-\\[\\#71717A\\] {
  --tw-text-opacity: 1;
  color: rgb(113 113 122 / var(--tw-text-opacity));
}.text-\\[\\#789C9C\\] {
  --tw-text-opacity: 1;
  color: rgb(120 156 156 / var(--tw-text-opacity));
}.text-\\[\\#8A94A6\\] {
  --tw-text-opacity: 1;
  color: rgb(138 148 166 / var(--tw-text-opacity));
}.text-\\[\\#B0B7C3\\] {
  --tw-text-opacity: 1;
  color: rgb(176 183 195 / var(--tw-text-opacity));
}.text-\\[\\#D7D7D7\\] {
  --tw-text-opacity: 1;
  color: rgb(215 215 215 / var(--tw-text-opacity));
}.text-\\[\\#DC2626\\] {
  --tw-text-opacity: 1;
  color: rgb(220 38 38 / var(--tw-text-opacity));
}.text-\\[\\#DDDFE3\\] {
  --tw-text-opacity: 1;
  color: rgb(221 223 227 / var(--tw-text-opacity));
}.text-\\[\\#E2E8F0\\] {
  --tw-text-opacity: 1;
  color: rgb(226 232 240 / var(--tw-text-opacity));
}.text-\\[\\#E3E3E3\\] {
  --tw-text-opacity: 1;
  color: rgb(227 227 227 / var(--tw-text-opacity));
}.text-\\[\\#F6F6F6\\] {
  --tw-text-opacity: 1;
  color: rgb(246 246 246 / var(--tw-text-opacity));
}.text-\\[\\#fefefe\\] {
  --tw-text-opacity: 1;
  color: rgb(254 254 254 / var(--tw-text-opacity));
}.text-\\[\\#ffffff80\\] {
  color: #ffffff80;
}.text-\\[\\#ffffff\\] {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity));
}.text-black {
  --tw-text-opacity: 1;
  color: rgb(0 0 0 / var(--tw-text-opacity));
}.text-foreground {
  color: var(--foreground);
}.text-secondary {
  color: var(--secondary);
}.text-white {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity));
}.underline {
  text-decoration-line: underline;
}.opacity-0 {
  opacity: 0;
}.opacity-100 {
  opacity: 1;
}.opacity-50 {
  opacity: 0.5;
}.shadow {
  --tw-shadow: 0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 1px 3px 0 var(--tw-shadow-color), 0 1px 2px -1px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}.shadow-lg {
  --tw-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}.shadow-none {
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}.shadow-xl {
  --tw-shadow: 0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 20px 25px -5px var(--tw-shadow-color), 0 8px 10px -6px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}.outline-none {
  outline: 2px solid transparent;
  outline-offset: 2px;
}.outline {
  outline-style: solid;
}.outline-1 {
  outline-width: 1px;
}.outline-transparent {
  outline-color: transparent;
}.filter {
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}.transition {
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, -webkit-backdrop-filter;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter, -webkit-backdrop-filter;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}.transition-colors {
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}.transition-opacity {
  transition-property: opacity;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}.duration-150 {
  transition-duration: 150ms;
}.duration-500 {
  transition-duration: 500ms;
}.ease-in-out {
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
}@font-face{font-family:"DMSans";src:url(${___CSS_LOADER_URL_REPLACEMENT_0___})}@font-face{font-family:"Inter";src:url(${___CSS_LOADER_URL_REPLACEMENT_1___})}@font-face{font-family:"CalSans";src:url(${___CSS_LOADER_URL_REPLACEMENT_2___})}@media(max-width: 767px){.stuck .intelli-heading {
    font-size: 20px;
    --tw-text-opacity: 1;
    color: rgb(255 255 255 / var(--tw-text-opacity));
  }@media (min-width: 768px) {

    .stuck .intelli-heading {
      font-size: 24px;
    }
  }}.font-300{font-weight:300}.font-400{font-weight:400}.font-500{font-weight:500}.hamburger-wrapper.active{background:linear-gradient(261.01deg, #82FAFF 2.69%, #37C5CB 17.46%, #47E0E7 32.23%, #279AA0 49.3%, #4CF7FF 67.77%, #17181D 98.69%);border-image-slice:1;border-radius:8px;box-shadow:0px 21.68px 30.81px 0px rgba(0,0,0,.3490196078) inset;padding:.57px}.hamburger-wrapper.active .hamburger{background:linear-gradient(94.26deg, #6DF9FF -4.13%, #20E1E9 111.26%)}.footer-get-started-text{background-image:linear-gradient(93.39deg, #FFFFFF 64.82%, #999999 99.4%);-webkit-background-clip:text;background-clip:text;-webkit-text-fill-color:rgba(0,0,0,0);color:#fff}@media screen and (max-width: 409px){.footer-get-started-text{font-size:22px !important}.get-started-link-item img{width:24px;height:24px}}.stikcy-header{background:linear-gradient(90deg, #0F0F0F 0%, #0D0D0D 100%) !important;box-shadow:0px 4px 24px 0px rgba(20,20,20,.2509803922) inset}.header-btn-group{border:1px solid #2e2e2e;border-color:#2e2e2e;border-radius:10px}.get-started-link-item .link-img-wrapper img.default{display:inline-block}.get-started-link-item .link-img-wrapper img.hover{display:none}.get-started-link-item:hover{border-color:#47e0e7}.get-started-link-item:hover .footer-get-started-text{background-image:linear-gradient(89.84deg, #47E0E7 53.39%, #85FAFF 81.44%, #24A2A8 99.86%)}.get-started-link-item:hover .link-img-wrapper img.default{display:none}.get-started-link-item:hover .link-img-wrapper img.hover{display:inline-block}.get-started-link:hover{color:#47e0e7 !important}#ask-answer-act-section{z-index:1}#features-section{z-index:2}#key-benefits-section{z-index:3}#pricing-section{z-index:4}#our-vision-section{z-index:5}.placeholder\\:text-\\[\\#B0B7C3\\]::placeholder {
  --tw-text-opacity: 1;
  color: rgb(176 183 195 / var(--tw-text-opacity));
}.placeholder\\:text-\\[\\#E2E8F0\\]::placeholder {
  --tw-text-opacity: 1;
  color: rgb(226 232 240 / var(--tw-text-opacity));
}.hover\\:\\!border-\\[\\#262525\\]:hover {
  --tw-border-opacity: 1 !important;
  border-color: rgb(38 37 37 / var(--tw-border-opacity)) !important;
}.hover\\:border-\\[\\#2DC6CC\\]:hover {
  --tw-border-opacity: 1;
  border-color: rgb(45 198 204 / var(--tw-border-opacity));
}.hover\\:\\!bg-secondary:hover {
  background-color: var(--secondary) !important;
}.hover\\:text-\\[\\#33DAE1\\]:hover {
  --tw-text-opacity: 1;
  color: rgb(51 218 225 / var(--tw-text-opacity));
}.hover\\:decoration-secondary:hover {
  text-decoration-color: var(--secondary);
}.hover\\:outline-\\[\\#2DC6CC\\]:hover {
  outline-color: #2DC6CC;
}.focus\\:border-\\[\\#2DC6CC\\]:focus {
  --tw-border-opacity: 1;
  border-color: rgb(45 198 204 / var(--tw-border-opacity));
}.focus\\:outline-none:focus {
  outline: 2px solid transparent;
  outline-offset: 2px;
}.focus\\:outline-\\[\\#2DC6CC\\]:focus {
  outline-color: #2DC6CC;
}.focus\\:ring-2:focus {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}.focus\\:ring-offset-2:focus {
  --tw-ring-offset-width: 2px;
}.active\\:border-\\[\\#2DC6CC\\]:active {
  --tw-border-opacity: 1;
  border-color: rgb(45 198 204 / var(--tw-border-opacity));
}.active\\:outline-\\[\\#2DC6CC\\]:active {
  outline-color: #2DC6CC;
}@media (min-width: 640px) {

  .sm\\:mt-0 {
    margin-top: 0px;
  }

  .sm\\:mt-12 {
    margin-top: 3rem;
  }

  .sm\\:block {
    display: block;
  }

  .sm\\:hidden {
    display: none;
  }

  .sm\\:h-\\[556px\\] {
    height: 556px;
  }

  .sm\\:flex-row {
    flex-direction: row;
  }

  .sm\\:items-start {
    align-items: flex-start;
  }

  .sm\\:items-center {
    align-items: center;
  }

  .sm\\:gap-10 {
    gap: 2.5rem;
  }

  .sm\\:gap-12 {
    gap: 3rem;
  }

  .sm\\:p-10 {
    padding: 2.5rem;
  }

  .sm\\:px-0 {
    padding-left: 0px;
    padding-right: 0px;
  }

  .sm\\:\\!text-\\[16px\\] {
    font-size: 16px !important;
  }

  .sm\\:text-\\[24px\\] {
    font-size: 24px;
  }

  .sm\\:text-\\[36px\\] {
    font-size: 36px;
  }

  .sm\\:\\!leading-\\[22px\\] {
    line-height: 22px !important;
  }

  .sm\\:leading-\\[32px\\] {
    line-height: 32px;
  }
}@media (min-width: 768px) {

  .md\\:col-span-1 {
    grid-column: span 1 / span 1;
  }

  .md\\:my-2\\.5 {
    margin-top: 0.625rem;
    margin-bottom: 0.625rem;
  }

  .md\\:my-\\[14px\\] {
    margin-top: 14px;
    margin-bottom: 14px;
  }

  .md\\:mb-0 {
    margin-bottom: 0px;
  }

  .md\\:mb-10 {
    margin-bottom: 2.5rem;
  }

  .md\\:mb-2 {
    margin-bottom: 0.5rem;
  }

  .md\\:mb-3 {
    margin-bottom: 0.75rem;
  }

  .md\\:mb-7 {
    margin-bottom: 1.75rem;
  }

  .md\\:mb-\\[60px\\] {
    margin-bottom: 60px;
  }

  .md\\:ml-\\[60px\\] {
    margin-left: 60px;
  }

  .md\\:mt-0 {
    margin-top: 0px;
  }

  .md\\:mt-1 {
    margin-top: 0.25rem;
  }

  .md\\:mt-10 {
    margin-top: 2.5rem;
  }

  .md\\:mt-2 {
    margin-top: 0.5rem;
  }

  .md\\:mt-3 {
    margin-top: 0.75rem;
  }

  .md\\:mt-4 {
    margin-top: 1rem;
  }

  .md\\:mt-5 {
    margin-top: 1.25rem;
  }

  .md\\:mt-7 {
    margin-top: 1.75rem;
  }

  .md\\:mt-\\[-60px\\] {
    margin-top: -60px;
  }

  .md\\:mt-\\[0px\\] {
    margin-top: 0px;
  }

  .md\\:mt-\\[37px\\] {
    margin-top: 37px;
  }

  .md\\:mt-\\[54px\\] {
    margin-top: 54px;
  }

  .md\\:mt-\\[70px\\] {
    margin-top: 70px;
  }

  .md\\:mt-\\[72px\\] {
    margin-top: 72px;
  }

  .md\\:block {
    display: block;
  }

  .md\\:flex {
    display: flex;
  }

  .md\\:grid {
    display: grid;
  }

  .md\\:hidden {
    display: none;
  }

  .md\\:h-10 {
    height: 2.5rem;
  }

  .md\\:h-12 {
    height: 3rem;
  }

  .md\\:h-6 {
    height: 1.5rem;
  }

  .md\\:h-\\[14px\\] {
    height: 14px;
  }

  .md\\:h-\\[48px\\] {
    height: 48px;
  }

  .md\\:w-1\\/2 {
    width: 50%;
  }

  .md\\:w-10 {
    width: 2.5rem;
  }

  .md\\:w-12 {
    width: 3rem;
  }

  .md\\:w-6 {
    width: 1.5rem;
  }

  .md\\:w-\\[14px\\] {
    width: 14px;
  }

  .md\\:w-\\[calc\\(100\\%-40px\\)\\] {
    width: calc(100% - 40px);
  }

  .md\\:w-fit {
    width: fit-content;
  }

  .md\\:max-w-\\[1200px\\] {
    max-width: 1200px;
  }

  .md\\:max-w-\\[473px\\] {
    max-width: 473px;
  }

  .md\\:max-w-\\[480px\\] {
    max-width: 480px;
  }

  .md\\:max-w-\\[490px\\] {
    max-width: 490px;
  }

  .md\\:max-w-\\[530px\\] {
    max-width: 530px;
  }

  .md\\:max-w-\\[637px\\] {
    max-width: 637px;
  }

  .md\\:max-w-\\[684px\\] {
    max-width: 684px;
  }

  .md\\:max-w-\\[757px\\] {
    max-width: 757px;
  }

  .md\\:max-w-\\[90\\%\\] {
    max-width: 90%;
  }

  .md\\:grid-cols-1 {
    grid-template-columns: repeat(1, minmax(0, 1fr));
  }

  .md\\:grid-cols-3 {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  .md\\:flex-row {
    flex-direction: row;
  }

  .md\\:flex-col {
    flex-direction: column;
  }

  .md\\:items-start {
    align-items: flex-start;
  }

  .md\\:items-center {
    align-items: center;
  }

  .md\\:justify-start {
    justify-content: flex-start;
  }

  .md\\:justify-center {
    justify-content: center;
  }

  .md\\:justify-between {
    justify-content: space-between;
  }

  .md\\:gap-1 {
    gap: 0.25rem;
  }

  .md\\:gap-10 {
    gap: 2.5rem;
  }

  .md\\:gap-16 {
    gap: 4rem;
  }

  .md\\:gap-3 {
    gap: 0.75rem;
  }

  .md\\:gap-5 {
    gap: 1.25rem;
  }

  .md\\:gap-6 {
    gap: 1.5rem;
  }

  .md\\:gap-\\[10px\\] {
    gap: 10px;
  }

  .md\\:gap-\\[40px\\] {
    gap: 40px;
  }

  .md\\:gap-\\[60px\\] {
    gap: 60px;
  }

  .md\\:gap-\\[79px\\] {
    gap: 79px;
  }

  .md\\:gap-x-1 {
    column-gap: 0.25rem;
  }

  .md\\:gap-y-10 {
    row-gap: 2.5rem;
  }

  .md\\:gap-y-8 {
    row-gap: 2rem;
  }

  .md\\:rounded-\\[60px\\] {
    border-radius: 60px;
  }

  .md\\:rounded-t-\\[60px\\] {
    border-top-left-radius: 60px;
    border-top-right-radius: 60px;
  }

  .md\\:border-none {
    border-style: none;
  }

  .md\\:p-0 {
    padding: 0px;
  }

  .md\\:p-2\\.5 {
    padding: 0.625rem;
  }

  .md\\:px-0 {
    padding-left: 0px;
    padding-right: 0px;
  }

  .md\\:px-10 {
    padding-left: 2.5rem;
    padding-right: 2.5rem;
  }

  .md\\:px-11 {
    padding-left: 2.75rem;
    padding-right: 2.75rem;
  }

  .md\\:px-12 {
    padding-left: 3rem;
    padding-right: 3rem;
  }

  .md\\:px-16 {
    padding-left: 4rem;
    padding-right: 4rem;
  }

  .md\\:px-5 {
    padding-left: 1.25rem;
    padding-right: 1.25rem;
  }

  .md\\:px-6 {
    padding-left: 1.5rem;
    padding-right: 1.5rem;
  }

  .md\\:px-\\[14px\\] {
    padding-left: 14px;
    padding-right: 14px;
  }

  .md\\:px-\\[40px\\] {
    padding-left: 40px;
    padding-right: 40px;
  }

  .md\\:px-\\[44px\\] {
    padding-left: 44px;
    padding-right: 44px;
  }

  .md\\:px-\\[88px\\] {
    padding-left: 88px;
    padding-right: 88px;
  }

  .md\\:py-0 {
    padding-top: 0px;
    padding-bottom: 0px;
  }

  .md\\:py-11 {
    padding-top: 2.75rem;
    padding-bottom: 2.75rem;
  }

  .md\\:py-16 {
    padding-top: 4rem;
    padding-bottom: 4rem;
  }

  .md\\:py-20 {
    padding-top: 5rem;
    padding-bottom: 5rem;
  }

  .md\\:py-\\[100px\\] {
    padding-top: 100px;
    padding-bottom: 100px;
  }

  .md\\:py-\\[14\\.5px\\] {
    padding-top: 14.5px;
    padding-bottom: 14.5px;
  }

  .md\\:py-\\[30px\\] {
    padding-top: 30px;
    padding-bottom: 30px;
  }

  .md\\:py-\\[96px\\] {
    padding-top: 96px;
    padding-bottom: 96px;
  }

  .md\\:pb-0 {
    padding-bottom: 0px;
  }

  .md\\:pb-7 {
    padding-bottom: 1.75rem;
  }

  .md\\:pb-\\[180px\\] {
    padding-bottom: 180px;
  }

  .md\\:pb-\\[64px\\] {
    padding-bottom: 64px;
  }

  .md\\:pl-5 {
    padding-left: 1.25rem;
  }

  .md\\:pt-10 {
    padding-top: 2.5rem;
  }

  .md\\:text-left {
    text-align: left;
  }

  .md\\:\\!text-\\[100px\\] {
    font-size: 100px !important;
  }

  .md\\:\\!text-\\[12px\\] {
    font-size: 12px !important;
  }

  .md\\:\\!text-\\[14px\\] {
    font-size: 14px !important;
  }

  .md\\:\\!text-\\[16px\\] {
    font-size: 16px !important;
  }

  .md\\:\\!text-\\[18px\\] {
    font-size: 18px !important;
  }

  .md\\:\\!text-\\[20px\\] {
    font-size: 20px !important;
  }

  .md\\:\\!text-\\[22px\\] {
    font-size: 22px !important;
  }

  .md\\:\\!text-\\[26px\\] {
    font-size: 26px !important;
  }

  .md\\:\\!text-\\[42px\\] {
    font-size: 42px !important;
  }

  .md\\:\\!text-\\[44px\\] {
    font-size: 44px !important;
  }

  .md\\:\\!text-\\[54px\\] {
    font-size: 54px !important;
  }

  .md\\:\\!text-\\[65px\\] {
    font-size: 65px !important;
  }

  .md\\:text-3xl {
    font-size: 1.875rem;
    line-height: 2.25rem;
  }

  .md\\:text-\\[100px\\] {
    font-size: 100px;
  }

  .md\\:text-\\[12px\\] {
    font-size: 12px;
  }

  .md\\:text-\\[14px\\] {
    font-size: 14px;
  }

  .md\\:text-\\[16px\\] {
    font-size: 16px;
  }

  .md\\:text-\\[18px\\] {
    font-size: 18px;
  }

  .md\\:text-\\[20px\\] {
    font-size: 20px;
  }

  .md\\:text-\\[22px\\] {
    font-size: 22px;
  }

  .md\\:text-\\[24px\\] {
    font-size: 24px;
  }

  .md\\:text-\\[26px\\] {
    font-size: 26px;
  }

  .md\\:text-\\[28px\\] {
    font-size: 28px;
  }

  .md\\:text-\\[30px\\] {
    font-size: 30px;
  }

  .md\\:text-\\[44px\\] {
    font-size: 44px;
  }

  .md\\:text-\\[52px\\] {
    font-size: 52px;
  }

  .md\\:text-\\[54px\\] {
    font-size: 54px;
  }

  .md\\:text-\\[60px\\] {
    font-size: 60px;
  }

  .md\\:text-\\[72px\\] {
    font-size: 72px;
  }

  .md\\:text-\\[74px\\] {
    font-size: 74px;
  }

  .md\\:text-\\[88px\\] {
    font-size: 88px;
  }

  .md\\:text-base {
    font-size: 1rem;
    line-height: 1.5rem;
  }

  .md\\:text-sm {
    font-size: 0.875rem;
    line-height: 1.25rem;
  }

  .md\\:\\!font-\\[300\\] {
    font-weight: 300 !important;
  }

  .md\\:\\!font-\\[500\\] {
    font-weight: 500 !important;
  }

  .md\\:\\!font-light {
    font-weight: 300 !important;
  }

  .md\\:font-\\[300\\] {
    font-weight: 300;
  }

  .md\\:font-semibold {
    font-weight: 600;
  }

  .md\\:\\!leading-\\[20px\\] {
    line-height: 20px !important;
  }

  .md\\:\\!leading-\\[26px\\] {
    line-height: 26px !important;
  }

  .md\\:\\!leading-\\[28px\\] {
    line-height: 28px !important;
  }

  .md\\:\\!leading-\\[33px\\] {
    line-height: 33px !important;
  }

  .md\\:\\!leading-\\[67\\.5px\\] {
    line-height: 67.5px !important;
  }

  .md\\:leading-\\[125px\\] {
    line-height: 125px;
  }

  .md\\:leading-\\[20px\\] {
    line-height: 20px;
  }

  .md\\:leading-\\[24px\\] {
    line-height: 24px;
  }

  .md\\:leading-\\[26px\\] {
    line-height: 26px;
  }

  .md\\:leading-\\[27px\\] {
    line-height: 27px;
  }

  .md\\:leading-\\[28px\\] {
    line-height: 28px;
  }

  .md\\:leading-\\[34px\\] {
    line-height: 34px;
  }

  .md\\:leading-\\[36px\\] {
    line-height: 36px;
  }

  .md\\:leading-\\[55px\\] {
    line-height: 55px;
  }

  .md\\:leading-\\[66px\\] {
    line-height: 66px;
  }

  .md\\:leading-\\[78px\\] {
    line-height: 78px;
  }

  .md\\:leading-\\[84px\\] {
    line-height: 84px;
  }

  .md\\:\\!text-\\[\\#A9AAB0\\] {
    --tw-text-opacity: 1 !important;
    color: rgb(169 170 176 / var(--tw-text-opacity)) !important;
  }

  .md\\:\\!text-\\[\\#FEFEFE\\] {
    --tw-text-opacity: 1 !important;
    color: rgb(254 254 254 / var(--tw-text-opacity)) !important;
  }

  .md\\:\\!text-white {
    --tw-text-opacity: 1 !important;
    color: rgb(255 255 255 / var(--tw-text-opacity)) !important;
  }
}@media (min-width: 1024px) {

  .lg\\:mb-0 {
    margin-bottom: 0px;
  }

  .lg\\:mb-\\[96px\\] {
    margin-bottom: 96px;
  }

  .lg\\:mt-5 {
    margin-top: 1.25rem;
  }

  .lg\\:mt-\\[-60px\\] {
    margin-top: -60px;
  }

  .lg\\:mt-\\[20px\\] {
    margin-top: 20px;
  }

  .lg\\:mt-\\[60px\\] {
    margin-top: 60px;
  }

  .lg\\:block {
    display: block;
  }

  .lg\\:flex {
    display: flex;
  }

  .lg\\:grid {
    display: grid;
  }

  .lg\\:hidden {
    display: none;
  }

  .lg\\:w-\\[1024px\\] {
    width: 1024px;
  }

  .lg\\:w-\\[465px\\] {
    width: 465px;
  }

  .lg\\:w-\\[838px\\] {
    width: 838px;
  }

  .lg\\:w-\\[856px\\] {
    width: 856px;
  }

  .lg\\:w-auto {
    width: auto;
  }

  .lg\\:max-w-\\[272px\\] {
    max-width: 272px;
  }

  .lg\\:max-w-\\[406px\\] {
    max-width: 406px;
  }

  .lg\\:max-w-\\[838px\\] {
    max-width: 838px;
  }

  .lg\\:max-w-\\[921px\\] {
    max-width: 921px;
  }

  .lg\\:grid-cols-2 {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .lg\\:grid-cols-3 {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  .lg\\:grid-cols-4 {
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }

  .lg\\:flex-row {
    flex-direction: row;
  }

  .lg\\:items-start {
    align-items: flex-start;
  }

  .lg\\:gap-16 {
    gap: 4rem;
  }

  .lg\\:gap-4 {
    gap: 1rem;
  }

  .lg\\:gap-5 {
    gap: 1.25rem;
  }

  .lg\\:gap-6 {
    gap: 1.5rem;
  }

  .lg\\:gap-8 {
    gap: 2rem;
  }

  .lg\\:gap-\\[17px\\] {
    gap: 17px;
  }

  .lg\\:gap-\\[40px\\] {
    gap: 40px;
  }

  .lg\\:gap-x-4 {
    column-gap: 1rem;
  }

  .lg\\:p-0 {
    padding: 0px;
  }

  .lg\\:p-\\[120px\\] {
    padding: 120px;
  }

  .lg\\:px-7 {
    padding-left: 1.75rem;
    padding-right: 1.75rem;
  }

  .lg\\:py-\\[84px\\] {
    padding-top: 84px;
    padding-bottom: 84px;
  }

  .lg\\:pb-0 {
    padding-bottom: 0px;
  }

  .lg\\:text-left {
    text-align: left;
  }

  .lg\\:\\!text-\\[18px\\] {
    font-size: 18px !important;
  }

  .lg\\:text-4\\.5xl {
    font-size: 40px;
  }
}@media (min-width: 1280px) {

  .xl\\:mx-0 {
    margin-left: 0px;
    margin-right: 0px;
  }

  .xl\\:h-\\[587px\\] {
    height: 587px;
  }

  .xl\\:max-w-\\[1120px\\] {
    max-width: 1120px;
  }

  .xl\\:p-\\[74px\\] {
    padding: 74px;
  }

  .xl\\:\\!text-\\[14px\\] {
    font-size: 14px !important;
  }
}`, "",{"version":3,"sources":["webpack://./src/globals.scss"],"names":[],"mappings":"AAAA;EAAA,wBAAA;EAAA,wBAAA;EAAA,mBAAA;EAAA,mBAAA;EAAA,cAAA;EAAA,cAAA;EAAA,cAAA;EAAA,eAAA;EAAA,eAAA;EAAA,aAAA;EAAA,aAAA;EAAA,kBAAA;EAAA,sCAAA;EAAA,8BAAA;EAAA,6BAAA;EAAA,4BAAA;EAAA,eAAA;EAAA,oBAAA;EAAA,sBAAA;EAAA,uBAAA;EAAA,wBAAA;EAAA,kBAAA;EAAA,2BAAA;EAAA,4BAAA;EAAA,sCAAA;EAAA,kCAAA;EAAA,2BAAA;EAAA,sBAAA;EAAA,8BAAA;EAAA,YAAA;EAAA,kBAAA;EAAA,gBAAA;EAAA,iBAAA;EAAA,kBAAA;EAAA,cAAA;EAAA,gBAAA;EAAA,aAAA;EAAA,mBAAA;EAAA,qBAAA;EAAA,2BAAA;EAAA,yBAAA;EAAA,0BAAA;EAAA,2BAAA;EAAA,uBAAA;EAAA,wBAAA;EAAA,yBAAA;EAAA,sBAAA;EAAA,oBAAA;EAAA,sBAAA;EAAA,qBAAA;EAAA;AAAA;;AAAA;EAAA,wBAAA;EAAA,wBAAA;EAAA,mBAAA;EAAA,mBAAA;EAAA,cAAA;EAAA,cAAA;EAAA,cAAA;EAAA,eAAA;EAAA,eAAA;EAAA,aAAA;EAAA,aAAA;EAAA,kBAAA;EAAA,sCAAA;EAAA,8BAAA;EAAA,6BAAA;EAAA,4BAAA;EAAA,eAAA;EAAA,oBAAA;EAAA,sBAAA;EAAA,uBAAA;EAAA,wBAAA;EAAA,kBAAA;EAAA,2BAAA;EAAA,4BAAA;EAAA,sCAAA;EAAA,kCAAA;EAAA,2BAAA;EAAA,sBAAA;EAAA,8BAAA;EAAA,YAAA;EAAA,kBAAA;EAAA,gBAAA;EAAA,iBAAA;EAAA,kBAAA;EAAA,cAAA;EAAA,gBAAA;EAAA,aAAA;EAAA,mBAAA;EAAA,qBAAA;EAAA,2BAAA;EAAA,yBAAA;EAAA,0BAAA;EAAA,2BAAA;EAAA,uBAAA;EAAA,wBAAA;EAAA,yBAAA;EAAA,sBAAA;EAAA,oBAAA;EAAA,sBAAA;EAAA,qBAAA;EAAA;AAAA,CAAA;;CAAA,CAAA;;;CAAA;;AAAA;;;EAAA,sBAAA,EAAA,MAAA;EAAA,eAAA,EAAA,MAAA;EAAA,mBAAA,EAAA,MAAA;EAAA,qBAAA,EAAA,MAAA;AAAA;;AAAA;;EAAA,gBAAA;AAAA;;AAAA;;;;;;;;CAAA;;AAAA;;EAAA,gBAAA,EAAA,MAAA;EAAA,8BAAA,EAAA,MAAA,EAAA,MAAA;EAAA,WAAA,EAAA,MAAA;EAAA,+HAAA,EAAA,MAAA;EAAA,6BAAA,EAAA,MAAA;EAAA,+BAAA,EAAA,MAAA;EAAA,wCAAA,EAAA,MAAA;AAAA;;AAAA;;;CAAA;;AAAA;EAAA,SAAA,EAAA,MAAA;EAAA,oBAAA,EAAA,MAAA;AAAA;;AAAA;;;;CAAA;;AAAA;EAAA,SAAA,EAAA,MAAA;EAAA,cAAA,EAAA,MAAA;EAAA,qBAAA,EAAA,MAAA;AAAA;;AAAA;;CAAA;;AAAA;EAAA,yCAAA;UAAA,iCAAA;AAAA;;AAAA;;CAAA;;AAAA;;;;;;EAAA,kBAAA;EAAA,oBAAA;AAAA;;AAAA;;CAAA;;AAAA;EAAA,cAAA;EAAA,wBAAA;AAAA;;AAAA;;CAAA;;AAAA;;EAAA,mBAAA;AAAA;;AAAA;;;;;CAAA;;AAAA;;;;EAAA,+GAAA,EAAA,MAAA;EAAA,6BAAA,EAAA,MAAA;EAAA,+BAAA,EAAA,MAAA;EAAA,cAAA,EAAA,MAAA;AAAA;;AAAA;;CAAA;;AAAA;EAAA,cAAA;AAAA;;AAAA;;CAAA;;AAAA;;EAAA,cAAA;EAAA,cAAA;EAAA,kBAAA;EAAA,wBAAA;AAAA;;AAAA;EAAA,eAAA;AAAA;;AAAA;EAAA,WAAA;AAAA;;AAAA;;;;CAAA;;AAAA;EAAA,cAAA,EAAA,MAAA;EAAA,qBAAA,EAAA,MAAA;EAAA,yBAAA,EAAA,MAAA;AAAA;;AAAA;;;;CAAA;;AAAA;;;;;EAAA,oBAAA,EAAA,MAAA;EAAA,8BAAA,EAAA,MAAA;EAAA,gCAAA,EAAA,MAAA;EAAA,eAAA,EAAA,MAAA;EAAA,oBAAA,EAAA,MAAA;EAAA,oBAAA,EAAA,MAAA;EAAA,uBAAA,EAAA,MAAA;EAAA,cAAA,EAAA,MAAA;EAAA,SAAA,EAAA,MAAA;EAAA,UAAA,EAAA,MAAA;AAAA;;AAAA;;CAAA;;AAAA;;EAAA,oBAAA;AAAA;;AAAA;;;CAAA;;AAAA;;;;EAAA,0BAAA,EAAA,MAAA;EAAA,6BAAA,EAAA,MAAA;EAAA,sBAAA,EAAA,MAAA;AAAA;;AAAA;;CAAA;;AAAA;EAAA,aAAA;AAAA;;AAAA;;CAAA;;AAAA;EAAA,gBAAA;AAAA;;AAAA;;CAAA;;AAAA;EAAA,wBAAA;AAAA;;AAAA;;CAAA;;AAAA;;EAAA,YAAA;AAAA;;AAAA;;;CAAA;;AAAA;EAAA,6BAAA,EAAA,MAAA;EAAA,oBAAA,EAAA,MAAA;AAAA;;AAAA;;CAAA;;AAAA;EAAA,wBAAA;AAAA;;AAAA;;;CAAA;;AAAA;EAAA,0BAAA,EAAA,MAAA;EAAA,aAAA,EAAA,MAAA;AAAA;;AAAA;;CAAA;;AAAA;EAAA,kBAAA;AAAA;;AAAA;;CAAA;;AAAA;;;;;;;;;;;;;EAAA,SAAA;AAAA;;AAAA;EAAA,SAAA;EAAA,UAAA;AAAA;;AAAA;EAAA,UAAA;AAAA;;AAAA;;;EAAA,gBAAA;EAAA,SAAA;EAAA,UAAA;AAAA;;AAAA;;CAAA;AAAA;EAAA,UAAA;AAAA;;AAAA;;CAAA;;AAAA;EAAA,gBAAA;AAAA;;AAAA;;;CAAA;;AAAA;;EAAA,UAAA,EAAA,MAAA;EAAA,cAAA,EAAA,MAAA;AAAA;;AAAA;;CAAA;;AAAA;;EAAA,eAAA;AAAA;;AAAA;;CAAA;AAAA;EAAA,eAAA;AAAA;;AAAA;;;;CAAA;;AAAA;;;;;;;;EAAA,cAAA,EAAA,MAAA;EAAA,sBAAA,EAAA,MAAA;AAAA;;AAAA;;CAAA;;AAAA;;EAAA,eAAA;EAAA,YAAA;AAAA;;AAAA,wEAAA;AAAA;EAAA,aAAA;AAAA,CAAA,MAAA,qBAAA,CAAA,qBAAA,CAAA,kBAAA,CAAA,oBAAA,CAAA,gBAAA,CAAA,iBAAA,CAAA,iBAAA,CAAA,yBAAA,CAAA,wBAAA,CAAA,0BAAA,CAAA,gCAAA,CAAA,qBAAA,CAAA,6BAAA,CAAA,4BAAA,CAAA,8BAAA,CAAA,mBAAA,CAAA,2BAAA,CAAA,0BAAA,CAAA,aAAA,CAAA,EAAA,oBAAA,CAAA,+BAAA,CAAA;EAAA,uBAAA;EAAA,kBAAA;EAAA,mDAAA;EAAA;AAAA,CAAA,sCAAA;IAAA,kBAAA;IAAA;EAAA,CAAA,CAAA;EAAA,oBAAA;EAAA,gDAAA;EAAA;AAAA,CAAA,QAAA,aAAA,CAAA;EAAA,kBAAA;EAAA,qBAAA;EAAA,kBAAA;EAAA,mBAAA;EAAA,oBAAA;EAAA;AAAA,CAAA,qBAAA,UAAA,CAAA,WAAA,CAAA,qCAAA,iBAAA,gBAAA,CAAA,CAAA,YAAA,mBAAA,CAAA,aAAA,oBAAA,CAAA,cAAA,qBAAA,CAAA;EAAA,iBAAA;EAAA,+BAAA;EAAA,+BAAA;EAAA,kBAAA;EAAA,gBAAA;EAAA,sBAAA;EAAA,0BAAA,CAAA;AAAA,CAAA;EAAA,wBAAA;EAAA,6BAAA;EAAA,oBAAA;EAAA;AAAA,CAAA;EAAA,kBAAA;EAAA,yDAAA;EAAA;AAAA,CAAA,4CAAA,eAAA,CAAA;EAAA,kBAAA;EAAA,oBAAA;EAAA,gDAAA,CAAA;AAAA,CAAA;EAAA,iBAAA;EAAA,kCAAA;EAAA,sCAAA;EAAA,6BAAA,CAAA;AAAA,CAAA;EAAA,oBAAA;EAAA,gDAAA,CAAA,eAAA,CAAA;AAAA,CAAA;EAAA,uCAAA;EAAA;AAAA,CAAA;EAAA,mBAAA;EAAA,sBAAA;EAAA,wDAAA;EAAA,kBAAA;EAAA,wDAAA;EAAA,oBAAA;EAAA;AAAA,CAAA;EAAA,yBAAA;EAAA,aAAA;EAAA,YAAA;EAAA,qBAAA;EAAA,kBAAA;EAAA,wDAAA;EAAA,sBAAA;EAAA;AAAA,CAAA;EAAA,aAAA;EAAA,sBAAA;EAAA;AAAA,CAAA;EAAA,aAAA;EAAA,mBAAA;EAAA,8BAAA;EAAA,wBAAA;EAAA,sBAAA;EAAA,gEAAA;EAAA,iBAAA;EAAA,oBAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA,YAAA;EAAA,WAAA;EAAA;AAAA,CAAA;EAAA,kBAAA;EAAA,kBAAA;EAAA;AAAA,CAAA;EAAA,aAAA;EAAA,WAAA;EAAA,sBAAA;EAAA,4BAAA;EAAA,iBAAA;EAAA,sBAAA;EAAA,sDAAA;EAAA,wBAAA;EAAA,0BAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA,aAAA;EAAA,WAAA;EAAA,mBAAA;EAAA,8BAAA;EAAA,kBAAA;EAAA,sDAAA;EAAA,aAAA;EAAA,gBAAA;EAAA,mBAAA;EAAA,oBAAA;EAAA,oBAAA;EAAA;AAAA,CAAA;;EAAA;IAAA,kBAAA;IAAA;EAAA;AAAA,CAAA;;EAAA;IAAA,qBAAA;IAAA,sBAAA;IAAA,mBAAA;IAAA,sBAAA;IAAA,iBAAA;IAAA;EAAA;AAAA,CAAA;EAAA,oBAAA;EAAA,gDAAA;EAAA,wBAAA;EAAA,0BAAA;EAAA;AAAA,CAAA;EAAA,mBAAA;EAAA,+LAAA;EAAA;AAAA,CAAA;EAAA,aAAA;EAAA,uBAAA;EAAA,gBAAA;EAAA,kBAAA;EAAA,mBAAA;EAAA,gBAAA;EAAA,mBAAA;EAAA,mBAAA;EAAA,oBAAA;EAAA,UAAA;EAAA,wBAAA;EAAA,0BAAA;EAAA;AAAA,CAAA;;EAAA;IAAA,qBAAA;IAAA;EAAA;AAAA,CAAA;EAAA,uBAAA;EAAA,iBAAA;EAAA,oBAAA;EAAA;AAAA,CAAA;;EAAA;IAAA,iBAAA;IAAA;EAAA;AAAA,CAAA;EAAA,sBAAA;EAAA,yDAAA;EAAA;AAAA,CAAA;EAAA,mBAAA;EAAA,oBAAA;EAAA,gBAAA;EAAA,mBAAA;EAAA,oBAAA;EAAA;AAAA,CAAA;;EAAA;IAAA,mBAAA;IAAA;EAAA;AAAA,CAAA;EAAA,sBAAA;EAAA,yDAAA;EAAA,2BAAA;EAAA,oBAAA;EAAA;AAAA,CAAA;EAAA,oBAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA,oBAAA;EAAA,mBAAA;EAAA,mBAAA;EAAA,kBAAA;EAAA,kBAAA;EAAA,mBAAA;EAAA,uBAAA;EAAA,qBAAA;EAAA,kBAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA,kBAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA,8CAAA,YAAA,CACA;EAAA;AAAA,CAAA;;EAAA;IAAA;EAAA;AAAA,CAAA;;EAAA;IAAA;EAAA;AAAA,CAAA;;EAAA;IAAA;EAAA;AAAA,CAAA;;EAAA;IAAA;EAAA;AAAA,CAAA;;EAAA;IAAA;EAAA;AAAA,CACA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA,QAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA,gBAAA;EAAA;AAAA,CAAA;EAAA,iBAAA;EAAA;AAAA,CAAA;EAAA,oBAAA;EAAA;AAAA,CAAA;EAAA,iBAAA;EAAA;AAAA,CAAA;EAAA,eAAA;EAAA;AAAA,CAAA;EAAA,gBAAA;EAAA;AAAA,CAAA;EAAA,mBAAA;EAAA;AAAA,CAAA;EAAA,kBAAA;EAAA;AAAA,CAAA;EAAA,gBAAA;EAAA;AAAA,CAAA;EAAA,gBAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA,uBAAA;EAAA;AAAA,CAAA;EAAA,qBAAA;EAAA;AAAA,CAAA;EAAA,sBAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;;EAAA;IAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA,uBAAA;EAAA,+DAAA;EAAA;AAAA,CAAA;EAAA,uBAAA;EAAA,8DAAA;EAAA;AAAA,CAAA;EAAA,uBAAA;EAAA,4DAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA,gCAAA;EAAA;AAAA,CAAA;EAAA,4BAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA,sBAAA;EAAA;AAAA,CAAA;EAAA,sBAAA;EAAA;AAAA,CAAA;EAAA,sBAAA;EAAA;AAAA,CAAA;EAAA,sBAAA;EAAA;AAAA,CAAA;EAAA,sBAAA;EAAA;AAAA,CAAA;EAAA,sBAAA;EAAA;AAAA,CAAA;EAAA,sBAAA;EAAA;AAAA,CAAA;EAAA,sBAAA;EAAA;AAAA,CAAA;EAAA,sBAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA,6BAAA;EAAA;AAAA,CAAA;EAAA,6BAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA,kBAAA;EAAA;AAAA,CAAA;EAAA,kBAAA;EAAA;AAAA,CAAA;EAAA,kBAAA;EAAA;AAAA,CAAA;EAAA,kBAAA;EAAA;AAAA,CAAA;EAAA,kBAAA;EAAA;AAAA,CAAA;EAAA,kBAAA;EAAA;AAAA,CAAA;EAAA,kBAAA;EAAA;AAAA,CAAA;EAAA,kBAAA;EAAA;AAAA,CAAA;EAAA,kBAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA,kBAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA,4BAAA;EAAA;AAAA,CAAA;EAAA,+BAAA;EAAA;AAAA,CAAA;EAAA,6BAAA;EAAA;AAAA,CAAA;EAAA,2BAAA;EAAA;AAAA,CAAA;EAAA,6BAAA;EAAA;AAAA,CAAA;EAAA,6BAAA;EAAA;AAAA,CAAA;EAAA,iBAAA;EAAA;AAAA,CAAA;EAAA,sBAAA;EAAA;AAAA,CAAA;EAAA,oBAAA;EAAA;AAAA,CAAA;EAAA,oBAAA;EAAA;AAAA,CAAA;EAAA,sBAAA;EAAA;AAAA,CAAA;EAAA,qBAAA;EAAA;AAAA,CAAA;EAAA,kBAAA;EAAA;AAAA,CAAA;EAAA,qBAAA;EAAA;AAAA,CAAA;EAAA,oBAAA;EAAA;AAAA,CAAA;EAAA,kBAAA;EAAA;AAAA,CAAA;EAAA,kBAAA;EAAA;AAAA,CAAA;EAAA,kBAAA;EAAA;AAAA,CAAA;EAAA,kBAAA;EAAA;AAAA,CAAA;EAAA,oBAAA;EAAA;AAAA,CAAA;EAAA,iBAAA;EAAA;AAAA,CAAA;EAAA,qBAAA;EAAA;AAAA,CAAA;EAAA,oBAAA;EAAA;AAAA,CAAA;EAAA,mBAAA;EAAA;AAAA,CAAA;EAAA,iBAAA;EAAA;AAAA,CAAA;EAAA,iBAAA;EAAA;AAAA,CAAA;EAAA,mBAAA;EAAA;AAAA,CAAA;EAAA,qBAAA;EAAA;AAAA,CAAA;EAAA,oBAAA;EAAA;AAAA,CAAA;EAAA,iBAAA;EAAA;AAAA,CAAA;EAAA,oBAAA;EAAA;AAAA,CAAA;EAAA,iBAAA;EAAA;AAAA,CAAA;EAAA,iBAAA;EAAA;AAAA,CAAA;EAAA,iBAAA;EAAA;AAAA,CAAA;EAAA,gBAAA;EAAA;AAAA,CAAA;EAAA,gBAAA;EAAA;AAAA,CAAA;EAAA,iBAAA;EAAA;AAAA,CAAA;EAAA,gBAAA;EAAA;AAAA,CAAA;EAAA,kBAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA,iBAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA,eAAA;EAAA;AAAA,CAAA;EAAA,mBAAA;EAAA;AAAA,CAAA;EAAA,mBAAA;EAAA;AAAA,CAAA;EAAA,kBAAA;EAAA;AAAA,CAAA;EAAA,kBAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA,+BAAA;EAAA;AAAA,CAAA;EAAA,+BAAA;EAAA;AAAA,CAAA;EAAA,+BAAA;EAAA;AAAA,CAAA;EAAA,+BAAA;EAAA;AAAA,CAAA;EAAA,+BAAA;EAAA;AAAA,CAAA;EAAA,+BAAA;EAAA;AAAA,CAAA;EAAA,+BAAA;EAAA;AAAA,CAAA;EAAA,+BAAA;EAAA;AAAA,CAAA;EAAA,+BAAA;EAAA;AAAA,CAAA;EAAA,+BAAA;EAAA;AAAA,CAAA;EAAA,+BAAA;EAAA;AAAA,CAAA;EAAA,+BAAA;EAAA;AAAA,CAAA;EAAA,+BAAA;EAAA;AAAA,CAAA;EAAA,+BAAA;EAAA;AAAA,CAAA;EAAA,+BAAA;EAAA;AAAA,CAAA;EAAA,+BAAA;EAAA;AAAA,CAAA;EAAA,+BAAA;EAAA;AAAA,CAAA;EAAA,+BAAA;EAAA;AAAA,CAAA;EAAA,+BAAA;EAAA;AAAA,CAAA;EAAA,+BAAA;EAAA;AAAA,CAAA;EAAA,oBAAA;EAAA;AAAA,CAAA;EAAA,oBAAA;EAAA;AAAA,CAAA;EAAA,oBAAA;EAAA;AAAA,CAAA;EAAA,oBAAA;EAAA;AAAA,CAAA;EAAA,oBAAA;EAAA;AAAA,CAAA;EAAA,oBAAA;EAAA;AAAA,CAAA;EAAA,oBAAA;EAAA;AAAA,CAAA;EAAA,oBAAA;EAAA;AAAA,CAAA;EAAA,oBAAA;EAAA;AAAA,CAAA;EAAA,oBAAA;EAAA;AAAA,CAAA;EAAA,oBAAA;EAAA;AAAA,CAAA;EAAA,oBAAA;EAAA;AAAA,CAAA;EAAA,oBAAA;EAAA;AAAA,CAAA;EAAA,oBAAA;EAAA;AAAA,CAAA;EAAA,oBAAA;EAAA;AAAA,CAAA;EAAA,oBAAA;EAAA;AAAA,CAAA;EAAA,oBAAA;EAAA;AAAA,CAAA;EAAA,oBAAA;EAAA;AAAA,CAAA;EAAA,oBAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA,oBAAA;EAAA;AAAA,CAAA;EAAA,oBAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA,oBAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA,0EAAA;EAAA,8FAAA;EAAA;AAAA,CAAA;EAAA,+EAAA;EAAA,mGAAA;EAAA;AAAA,CAAA;EAAA,sBAAA;EAAA,8BAAA;EAAA;AAAA,CAAA;EAAA,gFAAA;EAAA,oGAAA;EAAA;AAAA,CAAA;EAAA,8BAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA,gKAAA;EAAA,wJAAA;EAAA,iLAAA;EAAA,wDAAA;EAAA;AAAA,CAAA;EAAA,+FAAA;EAAA,wDAAA;EAAA;AAAA,CAAA;EAAA,4BAAA;EAAA,wDAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CA8BA,WACE,oBAAA,CACA,2CAAA,CAGF,WACE,mBAAA,CACA,2CAAA,CAGF,WACE,qBAAA,CACA,2CAAA,CA6NF,yBAEI;IAAA,eAAA;IAAA,oBAAA;IAAA;EAAA,CAAA;;IAAA;MAAA;IAAA;EAAA,CAAA,CAIJ,UACE,eAAA,CAGF,UACE,eAAA,CAGF,UACE,eAAA,CAGF,0BACE,mIAAA,CACA,oBAAA,CACA,iBAAA,CACA,gEAAA,CACA,aAAA,CAEA,qCACE,qEAAA,CAIJ,yBACE,yEAAA,CACA,4BAAA,CACA,oBAAA,CACA,qCAAA,CACA,UAAA,CAGF,qCACE,yBACE,yBAAA,CAGF,2BACE,UAAA,CACA,WAAA,CAAA,CAIJ,eACE,sEAAA,CACA,4DAAA,CAGF,kBACE,wBAAA,CACA,oBAAA,CACA,kBAAA,CAKE,qDACE,oBAAA,CAGF,mDACE,YAAA,CAIJ,6BACE,oBAAA,CAEA,sDACE,0FAAA,CAIA,2DACE,YAAA,CAGF,yDACE,oBAAA,CAQN,wBACE,wBAAA,CAIJ,wBACE,SAAA,CAGF,kBACE,SAAA,CAGF,sBACE,SAAA,CAGF,iBACE,SAAA,CAGF,oBACE,SAAA,CA3XF;EAAA,oBA2XE;EA3XF;AA2XE,CA3XF;EAAA,oBA2XE;EA3XF;AA2XE,CA3XF;EAAA,iCA2XE;EA3XF;AA2XE,CA3XF;EAAA,sBA2XE;EA3XF;AA2XE,CA3XF;EAAA;AA2XE,CA3XF;EAAA,oBA2XE;EA3XF;AA2XE,CA3XF;EAAA;AA2XE,CA3XF;EAAA;AA2XE,CA3XF;EAAA,sBA2XE;EA3XF;AA2XE,CA3XF;EAAA,8BA2XE;EA3XF;AA2XE,CA3XF;EAAA;AA2XE,CA3XF;EAAA,2GA2XE;EA3XF,yGA2XE;EA3XF;AA2XE,CA3XF;EAAA;AA2XE,CA3XF;EAAA,sBA2XE;EA3XF;AA2XE,CA3XF;EAAA;AA2XE,CA3XF;;EAAA;IAAA;EA2XE;;EA3XF;IAAA;EA2XE;;EA3XF;IAAA;EA2XE;;EA3XF;IAAA;EA2XE;;EA3XF;IAAA;EA2XE;;EA3XF;IAAA;EA2XE;;EA3XF;IAAA;EA2XE;;EA3XF;IAAA;EA2XE;;EA3XF;IAAA;EA2XE;;EA3XF;IAAA;EA2XE;;EA3XF;IAAA;EA2XE;;EA3XF;IAAA,iBA2XE;IA3XF;EA2XE;;EA3XF;IAAA;EA2XE;;EA3XF;IAAA;EA2XE;;EA3XF;IAAA;EA2XE;;EA3XF;IAAA;EA2XE;;EA3XF;IAAA;EA2XE;AAAA,CA3XF;;EAAA;IAAA;EA2XE;;EA3XF;IAAA,oBA2XE;IA3XF;EA2XE;;EA3XF;IAAA,gBA2XE;IA3XF;EA2XE;;EA3XF;IAAA;EA2XE;;EA3XF;IAAA;EA2XE;;EA3XF;IAAA;EA2XE;;EA3XF;IAAA;EA2XE;;EA3XF;IAAA;EA2XE;;EA3XF;IAAA;EA2XE;;EA3XF;IAAA;EA2XE;;EA3XF;IAAA;EA2XE;;EA3XF;IAAA;EA2XE;;EA3XF;IAAA;EA2XE;;EA3XF;IAAA;EA2XE;;EA3XF;IAAA;EA2XE;;EA3XF;IAAA;EA2XE;;EA3XF;IAAA;EA2XE;;EA3XF;IAAA;EA2XE;;EA3XF;IAAA;EA2XE;;EA3XF;IAAA;EA2XE;;EA3XF;IAAA;EA2XE;;EA3XF;IAAA;EA2XE;;EA3XF;IAAA;EA2XE;;EA3XF;IAAA;EA2XE;;EA3XF;IAAA;EA2XE;;EA3XF;IAAA;EA2XE;;EA3XF;IAAA;EA2XE;;EA3XF;IAAA;EA2XE;;EA3XF;IAAA;EA2XE;;EA3XF;IAAA;EA2XE;;EA3XF;IAAA;EA2XE;;EA3XF;IAAA;EA2XE;;EA3XF;IAAA;EA2XE;;EA3XF;IAAA;EA2XE;;EA3XF;IAAA;EA2XE;;EA3XF;IAAA;EA2XE;;EA3XF;IAAA;EA2XE;;EA3XF;IAAA;EA2XE;;EA3XF;IAAA;EA2XE;;EA3XF;IAAA;EA2XE;;EA3XF;IAAA;EA2XE;;EA3XF;IAAA;EA2XE;;EA3XF;IAAA;EA2XE;;EA3XF;IAAA;EA2XE;;EA3XF;IAAA;EA2XE;;EA3XF;IAAA;EA2XE;;EA3XF;IAAA;EA2XE;;EA3XF;IAAA;EA2XE;;EA3XF;IAAA;EA2XE;;EA3XF;IAAA;EA2XE;;EA3XF;IAAA;EA2XE;;EA3XF;IAAA;EA2XE;;EA3XF;IAAA;EA2XE;;EA3XF;IAAA;EA2XE;;EA3XF;IAAA;EA2XE;;EA3XF;IAAA;EA2XE;;EA3XF;IAAA;EA2XE;;EA3XF;IAAA;EA2XE;;EA3XF;IAAA;EA2XE;;EA3XF;IAAA;EA2XE;;EA3XF;IAAA;EA2XE;;EA3XF;IAAA;EA2XE;;EA3XF;IAAA;EA2XE;;EA3XF;IAAA;EA2XE;;EA3XF;IAAA;EA2XE;;EA3XF;IAAA;EA2XE;;EA3XF;IAAA;EA2XE;;EA3XF;IAAA;EA2XE;;EA3XF;IAAA;EA2XE;;EA3XF;IAAA;EA2XE;;EA3XF;IAAA;EA2XE;;EA3XF;IAAA;EA2XE;;EA3XF;IAAA,4BA2XE;IA3XF;EA2XE;;EA3XF;IAAA;EA2XE;;EA3XF;IAAA;EA2XE;;EA3XF;IAAA;EA2XE;;EA3XF;IAAA,iBA2XE;IA3XF;EA2XE;;EA3XF;IAAA,oBA2XE;IA3XF;EA2XE;;EA3XF;IAAA,qBA2XE;IA3XF;EA2XE;;EA3XF;IAAA,kBA2XE;IA3XF;EA2XE;;EA3XF;IAAA,kBA2XE;IA3XF;EA2XE;;EA3XF;IAAA,qBA2XE;IA3XF;EA2XE;;EA3XF;IAAA,oBA2XE;IA3XF;EA2XE;;EA3XF;IAAA,kBA2XE;IA3XF;EA2XE;;EA3XF;IAAA,kBA2XE;IA3XF;EA2XE;;EA3XF;IAAA,kBA2XE;IA3XF;EA2XE;;EA3XF;IAAA,kBA2XE;IA3XF;EA2XE;;EA3XF;IAAA,gBA2XE;IA3XF;EA2XE;;EA3XF;IAAA,oBA2XE;IA3XF;EA2XE;;EA3XF;IAAA,iBA2XE;IA3XF;EA2XE;;EA3XF;IAAA,iBA2XE;IA3XF;EA2XE;;EA3XF;IAAA,kBA2XE;IA3XF;EA2XE;;EA3XF;IAAA,mBA2XE;IA3XF;EA2XE;;EA3XF;IAAA,iBA2XE;IA3XF;EA2XE;;EA3XF;IAAA,iBA2XE;IA3XF;EA2XE;;EA3XF;IAAA;EA2XE;;EA3XF;IAAA;EA2XE;;EA3XF;IAAA;EA2XE;;EA3XF;IAAA;EA2XE;;EA3XF;IAAA;EA2XE;;EA3XF;IAAA;EA2XE;;EA3XF;IAAA;EA2XE;;EA3XF;IAAA;EA2XE;;EA3XF;IAAA;EA2XE;;EA3XF;IAAA;EA2XE;;EA3XF;IAAA;EA2XE;;EA3XF;IAAA;EA2XE;;EA3XF;IAAA;EA2XE;;EA3XF;IAAA;EA2XE;;EA3XF;IAAA;EA2XE;;EA3XF;IAAA;EA2XE;;EA3XF;IAAA;EA2XE;;EA3XF;IAAA;EA2XE;;EA3XF;IAAA;EA2XE;;EA3XF;IAAA,mBA2XE;IA3XF;EA2XE;;EA3XF;IAAA;EA2XE;;EA3XF;IAAA;EA2XE;;EA3XF;IAAA;EA2XE;;EA3XF;IAAA;EA2XE;;EA3XF;IAAA;EA2XE;;EA3XF;IAAA;EA2XE;;EA3XF;IAAA;EA2XE;;EA3XF;IAAA;EA2XE;;EA3XF;IAAA;EA2XE;;EA3XF;IAAA;EA2XE;;EA3XF;IAAA;EA2XE;;EA3XF;IAAA;EA2XE;;EA3XF;IAAA;EA2XE;;EA3XF;IAAA;EA2XE;;EA3XF;IAAA;EA2XE;;EA3XF;IAAA;EA2XE;;EA3XF;IAAA;EA2XE;;EA3XF;IAAA;EA2XE;;EA3XF;IAAA,eA2XE;IA3XF;EA2XE;;EA3XF;IAAA,mBA2XE;IA3XF;EA2XE;;EA3XF;IAAA;EA2XE;;EA3XF;IAAA;EA2XE;;EA3XF;IAAA;EA2XE;;EA3XF;IAAA;EA2XE;;EA3XF;IAAA;EA2XE;;EA3XF;IAAA;EA2XE;;EA3XF;IAAA;EA2XE;;EA3XF;IAAA;EA2XE;;EA3XF;IAAA;EA2XE;;EA3XF;IAAA;EA2XE;;EA3XF;IAAA;EA2XE;;EA3XF;IAAA;EA2XE;;EA3XF;IAAA;EA2XE;;EA3XF;IAAA;EA2XE;;EA3XF;IAAA;EA2XE;;EA3XF;IAAA;EA2XE;;EA3XF;IAAA;EA2XE;;EA3XF;IAAA;EA2XE;;EA3XF;IAAA;EA2XE;;EA3XF;IAAA;EA2XE;;EA3XF;IAAA;EA2XE;;EA3XF;IAAA;EA2XE;;EA3XF;IAAA,+BA2XE;IA3XF;EA2XE;;EA3XF;IAAA,+BA2XE;IA3XF;EA2XE;;EA3XF;IAAA,+BA2XE;IA3XF;EA2XE;AAAA,CA3XF;;EAAA;IAAA;EA2XE;;EA3XF;IAAA;EA2XE;;EA3XF;IAAA;EA2XE;;EA3XF;IAAA;EA2XE;;EA3XF;IAAA;EA2XE;;EA3XF;IAAA;EA2XE;;EA3XF;IAAA;EA2XE;;EA3XF;IAAA;EA2XE;;EA3XF;IAAA;EA2XE;;EA3XF;IAAA;EA2XE;;EA3XF;IAAA;EA2XE;;EA3XF;IAAA;EA2XE;;EA3XF;IAAA;EA2XE;;EA3XF;IAAA;EA2XE;;EA3XF;IAAA;EA2XE;;EA3XF;IAAA;EA2XE;;EA3XF;IAAA;EA2XE;;EA3XF;IAAA;EA2XE;;EA3XF;IAAA;EA2XE;;EA3XF;IAAA;EA2XE;;EA3XF;IAAA;EA2XE;;EA3XF;IAAA;EA2XE;;EA3XF;IAAA;EA2XE;;EA3XF;IAAA;EA2XE;;EA3XF;IAAA;EA2XE;;EA3XF;IAAA;EA2XE;;EA3XF;IAAA;EA2XE;;EA3XF;IAAA;EA2XE;;EA3XF;IAAA;EA2XE;;EA3XF;IAAA;EA2XE;;EA3XF;IAAA;EA2XE;;EA3XF;IAAA;EA2XE;;EA3XF;IAAA;EA2XE;;EA3XF;IAAA;EA2XE;;EA3XF;IAAA,qBA2XE;IA3XF;EA2XE;;EA3XF;IAAA,iBA2XE;IA3XF;EA2XE;;EA3XF;IAAA;EA2XE;;EA3XF;IAAA;EA2XE;;EA3XF;IAAA;EA2XE;;EA3XF;IAAA;EA2XE;AAAA,CA3XF;;EAAA;IAAA,gBA2XE;IA3XF;EA2XE;;EA3XF;IAAA;EA2XE;;EA3XF;IAAA;EA2XE;;EA3XF;IAAA;EA2XE;;EA3XF;IAAA;EA2XE;AAAA","sourcesContent":["@tailwind base;@tailwind components;@tailwind utilities;@layer base{:root{--background: #0E0E0E;--foreground: #d7d7d7;--primary: #17181d;--secondary: #47E0E7;--third: #272d31;--active: #262d31;--btn-bg: #47E0E7;--btn-bg--active: #33DAE1;--btn-bg--hover: #47E0E7;--btn-bg--outline: #30393C;--btn-bg--outline-hover: #262525;--btn-border: #2DC6CC;--btn-border--active: #33DAE1;--btn-border--hover: #33DAE1;--btn-border--outline: #30393C;--btn-text: #000000;--btn-text--active: #000000;--btn-text--hover: #000000;--radius: 5px}}@font-face{font-family:\"DMSans\";src:url(\"../public/fonts/DMSans.ttf\")}@font-face{font-family:\"Inter\";src:url(\"../public/fonts/Inter-VariableFont_opsz,wght.ttf\")}@font-face{font-family:\"CalSans\";src:url(\"../public/fonts/CalSans-SemiBold.ttf\")}@layer base{*{@apply font-dmSans}body{@apply bg-black text-foreground scroll-smooth}@media screen and (max-width: 1024px){body .container{@apply px-4}}a{@apply text-white duration-150}a:hover{color:#47e0e7}button.hamburger{@apply text-white py-[6.5px] px-4}button.hamburger svg{width:18px;height:18px}@media screen and (max-width: 767px){button.hamburger{padding:9px 10px}}.font-inter{font-family:\"Inter\"}.font-dmSans{font-family:\"DMSans\"}.font-calSans{font-family:\"CalSans\"}.default-btn,.default-btn{@apply bg-btn-bg text-btn-text font-bold border border-btn-border duration-150 text-center;background:linear-gradient(90.47deg, #38C8CE 0.41%, #6DF9FF 65.55%, #20E1E9 112.38%)}.default-btn.outlined,.default-btn.outlined{@apply border-b bg-transparent text-white hover:bg-white hover:text-btn-text;background:none}.default-btn.secondary,.default-btn.secondary{@apply text-white border-none;background:none}.default-btn:hover:not(:disabled),.default-btn:hover:not(:disabled){@apply border border-btn-bg--hover bg-btn-bg--hover text-btn-text--hover;background:linear-gradient(90.47deg, #20E1E9 0.41%, #6DF9FF 65.55%, #38C8CE 112.38%)}.default-btn.secondary:hover:not(:disabled),.default-btn.secondary:hover:not(:disabled){@apply text-white;background:none;background-color:#262525}.default-btn:active:not(:disabled),.default-btn:active:not(:disabled){@apply bg-btn-bg--active text-btn-text--active}.default-btn:disabled,.default-btn:disabled{@apply bg-[#50797B] border-[#50797B] cursor-not-allowed text-[#27282C]}.orange-sun{@apply bg-[#ffa857] w-72 h-72 blur-[200px] rounded-full inset-[-20%_auto_auto_10%]}.footer{@apply flex flex-col gap-20}.footer .get-started{@apply flex items-center justify-between border-b-2 border-b-[#7f8292] hover:border-b-secondary duration-500 py-4}.footer .get-started img{@apply w-8 h-8 duration-500}.footer .get-started:hover img{@apply scale-125}.faq{@apply rounded w-full border-2 border-[#3b3b3b] flex flex-col hover:border-secondary transition-all duration-300 ease-in-out}.faq button.faq-btn{@apply text-lg md:text-xl lg:text-2xl text-white p-4 lg:px-5 lg:py-6 text-left w-full bg-[#292b32] flex items-center justify-between}.faq button.faq-btn span{@apply text-[#6b7094] transition-all duration-300 ease-in-out}.faq button.faq-btn.opened span{@apply rotate-180 text-secondary}.faq .answer{@apply grid overflow-hidden transition-all duration-300 ease-in-out px-4 lg:px-5 text-lg grid-rows-[0fr] opacity-0 py-0}.faq .answer.opened{@apply grid-rows-[1fr] opacity-100 py-4 lg:py-8}.btn-plan{@apply h-[73px] flex flex-col items-center justify-center gap-2 px-2.5 py-4 border border-[#747474] hover:border-[#AEE4E6] rounded-md hover:bg-[#AEE4E61A] duration-150}.btn-plan.active{@apply bg-[#AEE4E61A] border-[#AEE4E6]}.btn-tier{@apply p-4 xl:px-6 xl:py-5 rounded border border-[#686868] flex flex-col gap-5 duration-150 cursor-pointer text-[#ACACAC]}.btn-tier *{@apply duration-150}.btn-tier .name{@apply text-[#ACACAC] font-bold text-sm xl:text-lg leading-[21.6px]}.btn-tier:hover,.btn-tier.active{@apply border-[#AEE4E6] bg-[#AEE4E61A] text-[#E3E3E3]}.btn-tier:hover .name,.btn-tier.active .name{@apply text-[#AEE4E6]}.btn-tier .icon-wrapper>svg{@apply absolute duration-150}.btn-tier .icon-wrapper>svg.icon{@apply opacity-100}.btn-tier .icon-wrapper>svg.icon--selected{@apply opacity-0}.btn-tier.active .icon-wrapper .icon{@apply opacity-0}.btn-tier.active .icon-wrapper .icon--selected{@apply opacity-100}.btn-tier .benefit-item{@apply flex gap-3 text-[#E3E3E3] text-sm xl:text-lg leading-5}.btn-tier .benefit-item .icon{@apply min-w-5 max-w-5 min-h-5 max-h-5 inline-flex items-center justify-center bg-[#FFF] rounded-full}.btn-tier .benefit-item .icon svg{@apply opacity-0}.btn-tier.active .benefit-item .icon{@apply bg-[#AEE4E6]}.btn-tier.active .benefit-item .icon svg{@apply opacity-100}.btn-tier.active .benefit-item .icon svg path{fill:#17181d}.input-email{@apply h-16 p-5 border border-[#747474] rounded-md placeholder:text-[#ABABAB] text-lg font-medium text-white bg-transparent duration-150 hover:border-secondary outline-none hover:bg-[#AEE4E61A]}}@media(max-width: 767px){.stuck .intelli-heading{@apply text-[20px] md:text-[24px] text-white}}.font-300{font-weight:300}.font-400{font-weight:400}.font-500{font-weight:500}.hamburger-wrapper.active{background:linear-gradient(261.01deg, #82FAFF 2.69%, #37C5CB 17.46%, #47E0E7 32.23%, #279AA0 49.3%, #4CF7FF 67.77%, #17181D 98.69%);border-image-slice:1;border-radius:8px;box-shadow:0px 21.68px 30.81px 0px rgba(0,0,0,.3490196078) inset;padding:.57px}.hamburger-wrapper.active .hamburger{background:linear-gradient(94.26deg, #6DF9FF -4.13%, #20E1E9 111.26%)}.footer-get-started-text{background-image:linear-gradient(93.39deg, #FFFFFF 64.82%, #999999 99.4%);-webkit-background-clip:text;background-clip:text;-webkit-text-fill-color:rgba(0,0,0,0);color:#fff}@media screen and (max-width: 409px){.footer-get-started-text{font-size:22px !important}.get-started-link-item img{width:24px;height:24px}}.stikcy-header{background:linear-gradient(90deg, #0F0F0F 0%, #0D0D0D 100%) !important;box-shadow:0px 4px 24px 0px rgba(20,20,20,.2509803922) inset}.header-btn-group{border:1px solid #2e2e2e;border-color:#2e2e2e;border-radius:10px}.get-started-link-item .link-img-wrapper img.default{display:inline-block}.get-started-link-item .link-img-wrapper img.hover{display:none}.get-started-link-item:hover{border-color:#47e0e7}.get-started-link-item:hover .footer-get-started-text{background-image:linear-gradient(89.84deg, #47E0E7 53.39%, #85FAFF 81.44%, #24A2A8 99.86%)}.get-started-link-item:hover .link-img-wrapper img.default{display:none}.get-started-link-item:hover .link-img-wrapper img.hover{display:inline-block}.get-started-link:hover{color:#47e0e7 !important}#ask-answer-act-section{z-index:1}#features-section{z-index:2}#key-benefits-section{z-index:3}#pricing-section{z-index:4}#our-vision-section{z-index:5}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
